export const LANGS = [
    { code: "id", name: "Indonesia", flag: "🇮🇩" },
    { code: "en", name: "English", flag: "🇬🇧" },
    { code: "jv", name: "Basa Jawa", flag: "🇮🇩" },
    { code: "su", name: "Basa Sunda", flag: "🇮🇩" },
    { code: "ms", name: "Melayu", flag: "🇲🇾" },
    { code: "tl", name: "Filipino", flag: "🇵🇭" },
    { code: "th", name: "ไทย", flag: "🇹🇭" },
    { code: "vi", name: "Tiếng Việt", flag: "🇻🇳" },
    { code: "zh", name: "中文", loc: "zh-CN", flag: "🇨🇳" },
    { code: "ja", name: "日本語", flag: "🇯🇵" },
    { code: "ko", name: "한국어", flag: "🇰🇷" },
    { code: "hi", name: "हिन्दी", flag: "🇮🇳" },
    { code: "bn", name: "বাংলা", flag: "🇧🇩" },
    { code: "ur", name: "اردو", flag: "🇵🇰" },
    { code: "ar", name: "العربية", flag: "🇸🇦" },
    { code: "tr", name: "Türkçe", flag: "🇹🇷" },
    { code: "ru", name: "Русский", flag: "🇷🇺" },
    { code: "es", name: "Español", flag: "🇪🇸" },
    { code: "pt", name: "Português", loc: "pt-BR", flag: "🇧🇷" },
    { code: "fr", name: "Français", flag: "🇫🇷" },
    { code: "de", name: "Deutsch", flag: "🇩🇪" },
    { code: "nl", name: "Nederlands", flag: "🇳🇱" },
    { code: "it", name: "Italiano", flag: "🇮🇹" },
    { code: "sw", name: "Kiswahili", flag: "🇰🇪" },
];

export const RTL = ["ar", "ur"];

export const STRINGS = {
    id: {
        n1: "Kalkulator", n2: "Cara Kerja", n3: "FAQ", n4: "Hitung Refund", n5: "Bagikan Refundaja",
        badge: "KALKULATOR REFUND PREMIUM",
        h1a: "Refund aplikasi", h1b: "premium, dihitung", h1c1: "sampai", h1c2: "rupiah.",
        sub: "Masukkan harga, durasi, dan sisa masa aktif langgananmu — Refundaja menghitung estimasi dana kembalinya dalam sekejap. Gratis, tanpa login.",
        cta1: "Hitung Refund Sekarang", cta2: "Lihat Cara Kerja",
        c1: "100% gratis", c2: "Hasil instan", c3: "Tanpa login",
        ke: "KALKULATOR", kt1: "Berapa yang bisa kamu tarik", kt2: "kembali?",
        kd: "Semua dihitung langsung di browser kamu — hasilnya berubah seketika setiap kali kamu mengetik.",
        t1: "Hitung Refund", t2: "Hitung Sisa Hari",
        f1: "Nama Aplikasi", f1p: "Contoh: Netflix, Spotify…", f2: "Harga Beli (Rp)",
        f2h: "Masukkan harga dasar tanpa biaya admin. Contoh: bayar Rp 30.260 → isi Rp 30.000",
        f3: "Sisa Masa Aktif (Hari)", f4: "Total Durasi Premium (Hari)", f5: "Rate Refund",
        fH: "Harga", fD: "Durasi", fS: "Sisa Hari",
        r1: "Total Refund", r2: "isi form untuk menghitung", r3: "Estimasi refund", r4: "Sisa Durasi",
        r5: "Nilai per hari", r6: "Service Fee",
        r7: "Estimasi — bukan angka final dari penyedia layanan. Rumus: (harga ÷ durasi) × sisa hari × rate.",
        s2: "Tanggal Pembelian", s3: "Durasi Langganan", s4p: "Contoh: 45", s5: "Reset",
        s6: "Masih aktif", s7: "Kedaluwarsa", s8: "hari tersisa", s9: "hari berlalu", s10: "hari total",
        s11: "Mulai", s12: "Berakhir", s13: "Simpan ke Kalender", s14: "Tersimpan",
        s16: "pilih durasi Custom & isi jumlah hari",
        w1: "MENGAPA REFUNDAJA", w2a: "Kecil, tapi", w2b: "serius.",
        w3t: "Rumus terbuka, tanpa tebak-tebakan",
        wfd: "Setiap rupiah bisa kamu telusuri. Tidak ada angka ajaib — hanya aritmetika sederhana yang transparan.",
        w4t: "Instan & real-time", w4d: "Hasil berubah begitu kamu mengetik. Tidak perlu tombol hitung.",
        w5t: "Rate fleksibel", w5d: "Geser dari 10% sampai 100% — sesuaikan dengan kesepakatanmu.",
        w6t: "Gratis & privat", w6d: "Semua perhitungan terjadi di browser kamu. Tidak ada data yang dikirim, disimpan, atau dimintai akun.",
        h0: "CARA KERJA", ha: "Tiga langkah,", hb: "selesai.",
        h1t: "Isi detail langganan", h1d: "Nama aplikasi, harga beli, dan total durasi premium-nya — misal 30 hari.",
        h2t: "Masukkan sisa masa aktif", h2d: "Berapa hari yang masih tersisa sebelum langgananmu habis.",
        h3t: "Atur rate, lihat hasilnya", h3d: "Geser rate refund 10%–100%, dan estimasimu langsung tampil.",
        fa: "Sering", fb: "ditanyakan.",
        q1: "Apakah Refundaja gratis?", a1: "Ya, 100% gratis dan selalu gratis. Tidak ada login, tidak ada iklan, tidak ada batas penghitungan.",
        q2: "Bagaimana cara kerja kalkulasinya?", a2: "Harga beli dibagi total durasi premium menjadi nilai per hari, lalu dikali sisa masa aktif dan rate refund yang kamu atur.",
        q3: "Apa itu rate refund?", a3: "Rate adalah persentase nilai sisa masa aktif yang disetujui untuk dikembalikan — 0.70 berarti 70%. Geser slidernya sesuai kesepakatanmu.",
        q4: "Apakah data saya disimpan?", a4: "Tidak. Seluruh perhitungan berjalan di browser kamu dan tidak ada satu pun data yang dikirim ke server.",
        q5: "Aplikasi apa saja yang didukung?", a5: "Semua layanan premium berlangganan — Netflix, Spotify, YouTube Premium, Canva, dan lainnya.",
        ft1: "Kalkulator refund aplikasi premium — instan, gratis, dan akurat.",
        ft2: "© 2026 Refundaja. Dibuat oleh kyuda ❤️",
        ft3: "Refundaja adalah alat estimasi independen dan tidak berafiliasi dengan penyedia layanan mana pun.",
    },
    en: {
        n1: "Calculator", n2: "How it works", n3: "FAQ", n4: "Calculate Refund", n5: "Share Refundaja",
        badge: "PREMIUM REFUND CALCULATOR",
        h1a: "Premium app refunds,", h1b: "counted", h1c1: "down to the last", h1c2: "rupiah.",
        sub: "Enter your price, duration, and remaining days — Refundaja estimates your money back in seconds. Free, no login.",
        cta1: "Calculate Your Refund", cta2: "See How It Works",
        c1: "100% free", c2: "Instant results", c3: "No login",
        ke: "CALCULATOR", kt1: "How much can you get", kt2: "back?",
        kd: "Everything is calculated right in your browser — results update as you type.",
        t1: "Calculate Refund", t2: "Days Remaining",
        f1: "App Name", f1p: "e.g. Netflix, Spotify…", f2: "Purchase Price (Rp)",
        f2h: "Enter the base price without admin fees. E.g. paid Rp 30,260 → enter Rp 30,000",
        f3: "Remaining Active Days", f4: "Total Premium Duration (Days)", f5: "Refund Rate",
        fH: "Price", fD: "Duration", fS: "Days left",
        r1: "Total Refund", r2: "fill the form to calculate", r3: "Estimated refund", r4: "Remaining Duration",
        r5: "Value per day", r6: "Service Fee",
        r7: "Estimate — not a final figure from the provider. Formula: (price ÷ duration) × days left × rate.",
        s2: "Purchase Date", s3: "Subscription Duration", s4p: "e.g. 45", s5: "Reset",
        s6: "Still active", s7: "Expired", s8: "days left", s9: "days elapsed", s10: "days total",
        s11: "Start", s12: "End", s13: "Save to Calendar", s14: "Saved",
        s16: "pick Custom duration & enter days",
        w1: "WHY REFUNDAJA", w2a: "Small, but", w2b: "serious.",
        w3t: "Open formula, no guesswork",
        wfd: "Every rupiah is traceable. No magic numbers — just simple, transparent arithmetic.",
        w4t: "Instant & real-time", w4d: "Results change as you type. No calculate button needed.",
        w5t: "Flexible rate", w5d: "Slide from 10% to 100% — match your own agreement.",
        w6t: "Free & private", w6d: "Everything is computed in your browser. No data sent, stored, or accounts required.",
        h0: "HOW IT WORKS", ha: "Three steps,", hb: "done.",
        h1t: "Enter subscription details", h1d: "App name, purchase price, and premium duration — e.g. 30 days.",
        h2t: "Add remaining active days", h2d: "How many days are left before your subscription ends.",
        h3t: "Set the rate, see results", h3d: "Slide the refund rate 10%–100% and your estimate appears.",
        fa: "Frequently", fb: "asked.",
        q1: "Is Refundaja free?", a1: "Yes — 100% free, forever. No login, no ads, no limits.",
        q2: "How does the calculation work?", a2: "The purchase price is divided by total duration for a daily value, then multiplied by days left and your refund rate.",
        q3: "What is the refund rate?", a3: "The percentage of remaining value agreed to be refunded — 0.70 means 70%. Slide it to match your deal.",
        q4: "Is my data stored?", a4: "No. Everything runs in your browser and nothing is sent to any server.",
        q5: "Which apps are supported?", a5: "Any premium subscription — Netflix, Spotify, YouTube Premium, Canva, and more.",
        ft1: "Premium app refund calculator — instant, free, and accurate.",
        ft2: "© 2026 Refundaja. Crafted with care.",
        ft3: "Refundaja is an independent estimation tool and is not affiliated with any provider.",
    },
    jv: {
        n1: "Kalkulator", n2: "Cara Kerja", n3: "FAQ", n4: "Ngetung Refund", n5: "Bagikan Refundaja",
        badge: "KALKULATOR REFUND PREMIUM",
        h1a: "Refund aplikasi", h1b: "premium, dipitung", h1c1: "nganti", h1c2: "rupiah.",
        sub: "Lebokna rego, durasi, lan sisa dina aktif langgananmu — Refundaja ngetung estimasi balikna cepat. Gratis, tanpa login.",
        cta1: "Ngetung Refund Saiki", cta2: "Delok Cara Kerja",
        c1: "100% gratis", c2: "Asil instan", c3: "Tanpa login",
        ke: "KALKULATOR", kt1: "Pira sing bisa", kt2: "bali?",
        kd: "Kabeh diwilang langsung nang browser-mu — asile ganti cepak saben ketik.",
        t1: "Ngetung Refund", t2: "Ngetung Sisa Dina",
        f1: "Jeneng Aplikasi", f1p: "Contone: Netflix, Spotify…", f2: "Rego Tuku (Rp)",
        f2h: "Lebokna rego dasar tanpa biaya admin. Contone: bayar Rp 30.260 → isi Rp 30.000",
        f3: "Sisa Dina Aktif", f4: "Total Durasi Premium (Dina)", f5: "Rate Refund",
        fH: "Rego", fD: "Durasi", fS: "Sisa Dina",
        r1: "Total Refund", r2: "isi formulir kanggo ngetung", r3: "Estimasi refund", r4: "Sisa Durasi",
        r5: "Regina saben dina", r6: "Service Fee",
        r7: "Estimasi — dudu angka final saka penyedia. Rumus: (rego ÷ durasi) × sisa dina × rate.",
        s2: "Dina Tuku", s3: "Durasi Langganan", s4p: "Contone: 45", s5: "Reset",
        s6: "Isih aktif", s7: "Kedaluwarsa", s8: "dina sisa", s9: "dina liwatan", s10: "dina total",
        s11: "Mulai", s12: "Rampung", s13: "Simpen nang Kalender", s14: "Tersimpen",
        s16: "pilih durasi Custom & lebokna dina",
        w1: "KENAPA REFUNDAJA", w2a: "Cilik, nanging", w2b: "serius.",
        w3t: "Rumus terbuka, ora ana pangapalan",
        wfd: "Saben rupiah bisa dilacak. Ora ana angka ajaib — mung aritmetika sederhana sing transparan.",
        w4t: "Instan & real-time", w4d: "Asil ganti begtu ketik. Ora perlu tombol hitung.",
        w5t: "Rate fleksibel", w5d: "Geser 10% nganti 100% — cocokna karo kesepakatanmu.",
        w6t: "Gratis & privat", w6d: "Kabeh diwilang nang browser-mu. Ora ana data sing dikirim utawa disimpen.",
        h0: "CARA KERJA", ha: "Telung langkah,", hb: "ricek.",
        h1t: "Isi detail langganan", h1d: "Jeneng aplikasi, rego tuku, lan total durasi premium — contone 30 dina.",
        h2t: "Lebokna sisa dina aktif", h2d: "Pira dina sing isih ana sadurunge langgananmu entek.",
        h3t: "Atur rate, delok asile", h3d: "Geser rate refund 10%–100%, estimasimu langsung metu.",
        fa: "Sering", fb: "ditakokake.",
        q1: "Apa Refundaja gratis?", a1: "Ya, 100% gratis lan tansah gratis. Ora login, ora iklan, ora watesan.",
        q2: "Pripun cara kerjane?", a2: "Rego tuku dibagi total durasi dadi rego saben dina, banjur dikali sisa dina lan rate refund.",
        q3: "Apa iku rate refund?", a3: "Rate yaiku persentase nilai sisa sing disetujui balik — 0.70 ateges 70%. Geser slidere sakarepmu.",
        q4: "Apa datamu disimpen?", a4: "Ora. Kabeh nang browser-mu, ora ana sing dikirim nang server.",
        q5: "Aplikasi apa sing didukung?", a5: "Kabeh langganan premium — Netflix, Spotify, YouTube Premium, Canva, lan liyane.",
        ft1: "Kalkulator refund aplikasi premium — instan, gratis, lan akurat.",
        ft2: "© 2026 Refundaja. Digawe kanthi teliti.",
        ft3: "Refundaja minangka alat estimasi mandiri lan ora afiliasi karo penyedia layanan.",
    },
    su: {
        n1: "Kalkulator", n2: "Cara Gawé", n3: "FAQ", n4: "Ngitung Refund", n5: "Bagikeun Refundaja",
        badge: "KALKULATOR REFUND PREMIUM",
        h1a: "Refund aplikasi", h1b: "premium, diitung", h1c1: "kana", h1c2: "rupiah.",
        sub: "Asupkeun harga, durasi, jeung sisa poé aktip langganan — Refundaja ngitung balikna gancang. Gratis, tanpa login.",
        cta1: "Ngitung Refund Ayeuna", cta2: "Tingali Cara Gawé",
        c1: "100% gratis", c2: "Hasil instan", c3: "Tanpa login",
        ke: "KALKULATOR", kt1: "Sabaraha anu bisa", kt2: "balik?",
        kd: "Sadayana diitung langsung di browser — hasilna ganti waktas unjal.",
        t1: "Ngitung Refund", t2: "Ngitung Sisa Poé",
        f1: "Ngaran Aplikasi", f1p: "Conto: Netflix, Spotify…", f2: "Harga Beuli (Rp)",
        f2h: "Asupkeun harga dasar tanpa biaya admin. Conto: mayar Rp 30.260 → tulis Rp 30.000",
        f3: "Sisa Poé Aktip", f4: "Total Durasi Premium (Poé)", f5: "Rate Refund",
        fH: "Harga", fD: "Durasi", fS: "Sisa Poé",
        r1: "Total Refund", r2: "eusi formulir pikeun ngitung", r3: "Éstimasi refund", r4: "Sisa Durasi",
        r5: "Nilai per poé", r6: "Service Fee",
        r7: "Éstimasi — sanés angka final ti penyedia. Rumus: (harga ÷ durasi) × sisa poé × rate.",
        s2: "Tanggal Beuli", s3: "Durasi Langganan", s4p: "Conto: 45", s5: "Reset",
        s6: "Can aktip", s7: "Kedaluwarsa", s8: "poé sisa", s9: "poé kaliwat", s10: "poé total",
        s11: "Mimiti", s12: "Réngké", s13: "Simpen kana Kalénder", s14: "Tersimpen",
        s16: "pilih durasi Custom & eusieun poé",
        w1: "KENAPA REFUNDAJA", w2a: "Leutik, tapi", w2b: "serius.",
        w3t: "Rumus kabuka, tanpa nebak-nebak",
        wfd: "Unggal rupiah bisa dilacok. Euweuh angka ajaib — ngan aritmetika basajan anu transparan.",
        w4t: "Instan & real-time", w4d: "Hasil ganti waktas unjal. Teu perlu tombol itung.",
        w5t: "Rate fléksibel", w5d: "Geser ti 10% nepi 100% — cocogkeun jeung kasapukan.",
        w6t: "Gratis & privat", w6d: "Sadayana diitung di browser. Euweuh data anu dikirim atawa disimpen.",
        h0: "CARA GAWÉ", ha: "Tilu léngkah,", hb: "beres.",
        h1t: "Eusi detail langganan", h1d: "Ngaran aplikasi, harga beuli, jeung total durasi premium — contona 30 poé.",
        h2t: "Asupkeun sisa poé aktip", h2d: "Sabaraha poé anu can aya sateuacan langganan réngké.",
        h3t: "Atur rate, tingali hasilna", h3d: "Geser rate refund 10%–100%, éstimasi langsung muncul.",
        fa: "Sering", fb: "ditaroskeun.",
        q1: "Naha Refundaja gratis?", a1: "Leres, 100% gratis sarta salawasna. Tanpa login, tanpa iklan, tanpa wates.",
        q2: "Kumaha cara gawéna?", a2: "Harga beuli dibagi total durasi jadi nilai per poé, tuluy dikalikeun sisa poé jeung rate.",
        q3: "Naon éta rate refund?", a3: "Rate nyaéta perséntase nilai sisa anu disatujuan balik — 0,90 hartosna 90%. Geser sliderna sakumaha kasapukan.",
        q4: "Naha data kuring disimpen?", a4: "Henteu. Sadayana di browser anjeun, euweuh anu dikirim ka server.",
        q5: "Aplikasi naon anu dirojong?", a5: "Sadayana langganan premium — Netflix, Spotify, YouTube Premium, Canva, jeung sajabana.",
        ft1: "Kalkulator refund aplikasi premium — instan, gratis, tur akurat.",
        ft2: "© 2026 Refundaja. Dijieun kalawan teliti.",
        ft3: "Refundaja mangrupikeun alat éstimasi mandiri sareng henteu berafiliasi sareng penyedia layanan.",
    },
    ms: {
        n1: "Kalkulator", n2: "Cara Kerja", n3: "FAQ", n4: "Kira Refund", n5: "Kongsi Refundaja",
        badge: "KALKULATOR REFUND PREMIUM",
        h1a: "Refund aplikasi", h1b: "premium, dikira", h1c1: "sehingga", h1c2: "rupiah.",
        sub: "Masukkan harga, tempoh, dan baki hari aktif — Refundaja mengira anggaran wang balik anda serta-merta. Percuma, tanpa log masuk.",
        cta1: "Kira Refund Sekarang", cta2: "Lihat Cara Kerja",
        c1: "100% percuma", c2: "Hasil segera", c3: "Tanpa log masuk",
        ke: "KALKULATOR", kt1: "Berapa yang boleh anda", kt2: "tarik balik?",
        kd: "Semua dikira terus dalam pelayar anda — hasil berubah setiap kali anda menaip.",
        t1: "Kira Refund", t2: "Kira Baki Hari",
        f1: "Nama Aplikasi", f1p: "Contoh: Netflix, Spotify…", f2: "Harga Belian (Rp)",
        f2h: "Masukkan harga asas tanpa caj admin. Contoh: bayar Rp 30.260 → isi Rp 30.000",
        f3: "Baki Hari Aktif", f4: "Jumlah Tempoh Premium (Hari)", f5: "Kadar Refund",
        fH: "Harga", fD: "Tempoh", fS: "Baki Hari",
        r1: "Jumlah Refund", r2: "isi borang untuk mengira", r3: "Anggaran refund", r4: "Baki Tempoh",
        r5: "Nilai sehari", r6: "Yuran Servis",
        r7: "Anggaran — bukan angka muktamad dari penyedia. Rumus: (harga ÷ tempoh) × baki hari × kadar.",
        s2: "Tarikh Belian", s3: "Tempoh Langganan", s4p: "Contoh: 45", s5: "Set Semula",
        s6: "Masih aktif", s7: "Tamat tempoh", s8: "hari baki", s9: "hari berlalu", s10: "hari jumlah",
        s11: "Mula", s12: "Tamat", s13: "Simpan ke Kalendar", s14: "Disimpan",
        s16: "pilih tempoh Custom & masukkan hari",
        w1: "KENAPA REFUNDAJA", w2a: "Kecil, tetapi", w2b: "serius.",
        w3t: "Formula terbuka, tanpa teka-teki",
        wfd: "Setiap rupiah boleh dikesan. Tiada angka ajaib — hanya aritmetik mudah yang telus.",
        w4t: "Segera & masa nyata", w4d: "Hasil berubah begitu anda menaip. Tiada butang kira.",
        w5t: "Kadar fleksibel", w5d: "Laras dari 10% hingga 100% — ikut persetujuan anda.",
        w6t: "Percuma & peribadi", w6d: "Semua pengiraan berlaku dalam pelayar anda. Tiada data dihantar atau disimpan.",
        h0: "CARA KERJA", ha: "Tiga langkah,", hb: "siap.",
        h1t: "Isi butiran langganan", h1d: "Nama aplikasi, harga belian, dan jumlah tempoh premium — cth 30 hari.",
        h2t: "Masukkan baki hari aktif", h2d: "Berapa hari lagi sebelum langganan anda tamat.",
        h3t: "Atur kadar, lihat hasil", h3d: "Laras kadar refund 10%–100%, anggaran terus muncul.",
        fa: "Soalan", fb: "lazim.",
        q1: "Adakah Refundaja percuma?", a1: "Ya, 100% percuma selamanya. Tiada log masuk, tiada iklan, tiada had.",
        q2: "Bagaimana pengiraan berfungsi?", a2: "Harga belian dibagi jumlah tempoh untuk nilai harian, kemudian dibaki dengan baki hari dan kadar refund.",
        q3: "Apakah itu kadar refund?", a3: "Kadar ialah peratusan nilai baki yang dipersetujui untuk dipulangkan — 0.70 bermakna 70%.",
        q4: "Adakah data saya disimpan?", a4: "Tidak. Semua pengiraan berjalan dalam pelayar anda dan tiada data dihantar ke pelayan.",
        q5: "Aplikasi apakah yang disokong?", a5: "Semua langganan premium — Netflix, Spotify, YouTube Premium, Canva, dan lain-lain.",
        ft1: "Kalkulator refund aplikasi premium — segera, percuma, dan tepat.",
        ft2: "© 2026 Refundaja. Dibuat dengan teliti.",
        ft3: "Refundaja ialah alat anggaran bebas dan tidak berafiliasi dengan mana-mana penyedia.",
    },
    tl: {
        n1: "Kalkulador", n2: "Paano Gumagana", n3: "FAQ", n4: "Kalkulahin ang Refund", n5: "Ibahagi ang Refundaja",
        badge: "PREMIUM REFUND CALCULATOR",
        h1a: "Refund ng premium", h1b: "apps, kinakalkula", h1c1: "hanggang", h1c2: "rupiah.",
        sub: "Ilagay ang presyo, tagal, at natitirang araw — kinakalkula ng Refundaja ang balik ng pera mo sa ilang segundo. Libre, walang login.",
        cta1: "Kalkulahin ang Refund", cta2: "Tingnan Paano Gumagana",
        c1: "100% libre", c2: "Instant na resulta", c3: "Walang login",
        ke: "KALKULATOR", kt1: "Magkano ang", kt2: "makukuha mo?",
        kd: "Lahat ay kinakalkula mismo sa browser mo — nagbabago ang resulta habang nagta-type ka.",
        t1: "Kalkulahin ang Refund", t2: "Natitirang Araw",
        f1: "Pangalan ng App", f1p: "Hal.: Netflix, Spotify…", f2: "Presyo ng Pagbili (Rp)",
        f2h: "Ilagay ang presyo nang walang admin fee. Hal.: nagbayad ng Rp 30.260 → ilagay na Rp 30.000",
        f3: "Natitirang Aktibong Araw", f4: "Kabuuang Tagal ng Premium (Araw)", f5: "Rate ng Refund",
        fH: "Presyo", fD: "Tagal", fS: "Natirang araw",
        r1: "Kabuuang Refund", r2: "punan ang form para kalkulahin", r3: "Tantiyang refund", r4: "Natitirang Durasyon",
        r5: "Halaga kada araw", r6: "Service Fee",
        r7: "Tantiya — hindi panghuling numero mula sa provider. Formula: (presyo ÷ tagal) × natirang araw × rate.",
        s2: "Petsa ng Pagbili", s3: "Tagal ng Subscription", s4p: "hal.: 45", s5: "I-reset",
        s6: "Aktibo pa", s7: "Pauwa na", s8: "araw na natitira", s9: "araw na lumipas", s10: "kabuuang araw",
        s11: "Simula", s12: "Wakas", s13: "I-save sa Kalendaryo", s14: "Na-save",
        s16: "pumili ng Custom na tagal at maglagay ng araw",
        w1: "BAKIT REFUNDAJA", w2a: "Maliit, pero", w2b: "seryoso.",
        w3t: "Bukas na formula, walang hula-hula",
        wfd: "Bawat rupiah ay masusubaybay. Walang magic numbers — simple at transparent na arithmetic lang.",
        w4t: "Instant & real-time", w4d: "Nagbabago ang resulta habang nagta-type ka. Walang button na kailangan.",
        w5t: "Flexible na rate", w5d: "I-slide mula 10% hanggang 100% — ayon sa pinagkasunduan mo.",
        w6t: "Libre & pribado", w6d: "Lahat ng kalkulasyon ay nasa browser mo. Walang data na ipinapadala o iniimbak.",
        h0: "PAANO GUMAGANA", ha: "Tatlong hakbang,", hb: "tapos.",
        h1t: "Ilagay ang detalye ng subscription", h1d: "Pangalan ng app, presyo ng pagbili, at kabuuang tagal ng premium — hal. 30 araw.",
        h2t: "Ilagay ang natitirang araw", h2d: "Ilang araw pa bago matapos ang subscription mo.",
        h3t: "Itakda ang rate, tingnan ang resulta", h3d: "I-slide ang refund rate 10%–100% at lalabas ang tantiya mo.",
        fa: "Mga Madalas", fb: "Itanong.",
        q1: "Libre ba ang Refundaja?", a1: "Oo — 100% libre, magpakailanman. Walang login, walang ads, walang limit.",
        q2: "Paano gumagana ang kalkulasyon?", a3: "", a2: "Ang presyo ay hinahati ng kabuuang tagal para sa halagang kada araw, tapos hinhati sa natirang araw at refund rate.",
        q3: "Ano ang refund rate?", a3: "Persentahe ng natitirang halaga na napagkasunduang ibabalik — 0.70 ay 70%.",
        q4: "Iniimbak ba ang data ko?", a4: "Hindi. Lahat ay tumatakbo sa browser mo at walang ipinapadala sa server.",
        q5: "Anong apps ang suportado?", a5: "Anumang premium subscription — Netflix, Spotify, YouTube Premium, Canva, at iba pa.",
        ft1: "Kalkulator ng refund ng premium apps — instant, libre, at tumpak.",
        ft2: "© 2026 Refundaja. Binuo nang may pag-iingat.",
        ft3: "Ang Refundaja ay isang malayang kasangkapan sa pagtantiya at hindi kaakibat ng anumang provider.",
    },
    th: {
        n1: "เครื่องคำนวณ", n2: "วิธีใช้งาน", n3: "FAQ", n4: "คำนวณเงินคืน", n5: "แชร์ Refundaja",
        badge: "เครื่องคำนวณเงินคืนพรีเมียม",
        h1a: "เงินคืนแอป", h1b: "พรีเมียม คำนวณ", h1c1: "ละเอียดถึง", h1c2: "รูเปียห์",
        sub: "ใส่ราคา ระยะเวลา และวันที่เหลือ — Refundaja คำนวณเงินที่ได้คืนในไม่กี่วินาที ฟรี ไม่ต้องล็อกอิน",
        cta1: "คำนวณเงินคืนเลย", cta2: "ดูวิธีใช้งาน",
        c1: "ฟรี 100%", c2: "ผลทันที", c3: "ไม่ต้องล็อกอิน",
        ke: "เครื่องคำนวณ", kt1: "คุณขอเงินคืนได้", kt2: "เท่าไร?",
        kd: "ทุกอย่างคำนวณในเบราว์เซอร์ของคุณ — ผลอัปเดตทันทีที่พิมพ์",
        t1: "คำนวณเงินคืน", t2: "คำนวณวันที่เหลือ",
        f1: "ชื่อแอป", f1p: "เช่น Netflix, Spotify…", f2: "ราคาที่ซื้อ (Rp)",
        f2h: "ใส่ราคาฐานไม่รวมค่าธรรมเนียม เช่น จ่าย Rp 30.260 → กรอก Rp 30.000",
        f3: "วันที่ยังเหลือ", f4: "ระยะเวลาพรีเมียมรวม (วัน)", f5: "อัตราเงินคืน",
        fH: "ราคา", fD: "ระยะเวลา", fS: "วันที่เหลือ",
        r1: "เงินคืนรวม", r2: "กรอกแบบฟอร์มเพื่อคำนวณ", r3: "เงินคืนโดยประมาณ", r4: "ระยะเวลาที่เหลือ",
        r5: "มูลค่าต่อวัน", r6: "ค่าบริการ",
        r7: "เป็นค่าประมาณ — ไม่ใช่ตัวเลขสุดท้ายจากผู้ให้บริการ สูตร: (ราคา ÷ ระยะเวลา) × วันที่เหลือ × อัตรา",
        s2: "วันที่ซื้อ", s3: "ระยะเวลาสมัคร", s4p: "เช่น 45", s5: "รีเซ็ต",
        s6: "ยังใช้งานได้", s7: "หมดอายุ", s8: "วันที่เหลือ", s9: "วันที่ผ่านไป", s10: "วันรวม",
        s11: "เริ่ม", s12: "สิ้นสุด", s13: "บันทึกลงปฏิทิน", s14: "บันทึกแล้ว",
        s16: "เลือกระยะเวลาแบบกำหนดเองแล้วใส่จำนวนวัน",
        w1: "ทำไมต้อง REFUNDAJA", w2a: "เล็ก แต่", w2b: "จริงจัง",
        w3t: "สูตรเปิดเผย ไม่ต้องเดา",
        wfd: "ทุกรูเปียห์ตามได้ ไม่มีตัวเลขวิเศษ — มีแค่คณิตศาสตร์ง่าย ๆ ที่โปร่งใส",
        w4t: "ทันที & เรียลไทม์", w4d: "ผลเปลี่ยนทันทีที่พิมพ์ ไม่ต้องกดปุ่มคำนวณ",
        w5t: "อัตรายืดหยุ่น", w5d: "เลื่อนจาก 10% ถึง 100% — ตามข้อตกลงของคุณ",
        w6t: "ฟรี & เป็นส่วนตัว", w6d: "คำนวณทั้งหมดในเบราว์เซอร์ของคุณ ไม่มีการส่งหรือเก็บข้อมูล",
        h0: "วิธีใช้งาน", ha: "สามขั้นตอน", hb: "จบ!",
        h1t: "ใส่รายละเอียดการสมัคร", h1d: "ชื่อแอป ราคาที่ซื้อ และระยะเวลาพรีเมียมรวม — เช่น 30 วัน",
        h2t: "ใส่วันที่ยังเหลือ", h2d: "เหลืออีกกี่วันก่อนการสมัครของคุณหมด",
        h3t: "ตั้งอัตรา ดูผลลัพธ์", h3d: "เลื่อนอัตราเงินคืน 10%–100% แล้วผลจะขึ้นทันที",
        fa: "คำถาม", fb: "ที่พบบ่อย",
        q1: "Refundaja ฟรีหรือไม่?", a1: "ฟรี 100% ตลอดไป ไม่ต้องล็อกอิน ไม่มีโฆษณา ไม่จำกัด",
        q2: "การคำนวณทำงานอย่างไร?", a2: "ราคาหารด้วยระยะเวลารวมเป็นมูลค่าต่อวัน แล้วคูณวันที่เหลือและอัตราเงินคืน",
        q3: "อัตราเงินคืนคืออะไร?", a3: "เปอร์เซ็นต์ของมูลค่าที่เหลือที่ตกลงจะคืน — 0.70 หมายถึง 70%",
        q4: "ข้อมูลของฉันถูกเก็บไหม?", a4: "ไม่ ทุกอย่างทำงานในเบราว์เซอร์ของคุณ ไม่มีข้อมูลถูกส่งไปเซิร์ฟเวอร์",
        q5: "รองรับแอปอะไรบ้าง?", a5: "สมัครพรีเมียมทุกชนิด — Netflix, Spotify, YouTube Premium, Canva ฯลฯ",
        ft1: "เครื่องคำนวณเงินคืนแอปพรีเมียม — ทันที ฟรี และแม่นยำ",
        ft2: "© 2026 Refundaja สร้างด้วยความตั้งใจ",
        ft3: "Refundaja เป็นเครื่องมือประมาณการอิสระ ไม่เกี่ยวข้องกับผู้ให้บริการใด ๆ",
    },
    vi: {
        n1: "Máy tính", n2: "Cách hoạt động", n3: "FAQ", n4: "Tính hoàn tiền", n5: "Chia sẻ Refundaja",
        badge: "MÁY TÍNH HOÀN TIỀN PREMIUM",
        h1a: "Hoàn tiền ứng dụng", h1b: "premium, tính", h1c1: "tới từng", h1c2: "rupiah.",
        sub: "Nhập giá, thời hạn và số ngày còn lại — Refundaja tính số tiền được hoàn trong tích tắc. Miễn phí, không cần đăng nhập.",
        cta1: "Tính Hoàn Tiền Ngay", cta2: "Xem Cách Hoạt Động",
        c1: "Miễn phí 100%", c2: "Kết quả tức thì", c3: "Không cần đăng nhập",
        ke: "MÁY TÍNH", kt1: "Bạn có thể nhận lại", kt2: "bao nhiêu?",
        kd: "Mọi thứ được tính ngay trong trình duyệt của bạn — kết quả thay đổi khi bạn gõ.",
        t1: "Tính Hoàn Tiền", t2: "Tính Số Ngày Còn Lại",
        f1: "Tên Ứng Dụng", f1p: "VD: Netflix, Spotify…", f2: "Giá Mua (Rp)",
        f2h: "Nhập giá gốc chưa phí quản lý. VD: trả Rp 30.260 → nhập Rp 30.000",
        f3: "Số Ngày Còn Hiệu Lực", f4: "Tổng Thời Hạn Premium (Ngày)", f5: "Tỷ Lệ Hoàn Tiền",
        fH: "Giá", fD: "Thời hạn", fS: "Ngày còn lại",
        r1: "Tổng Hoàn Tiền", r2: "điền form để tính", r3: "Hoàn tiền ước tính", r4: "Thời Hạn Còn Lại",
        r5: "Giá trị mỗi ngày", r6: "Phí dịch vụ",
        r7: "Ước tính — không phải con số cuối cùng từ nhà cung cấp. Công thức: (giá ÷ thời hạn) × ngày còn lại × tỷ lệ.",
        s2: "Ngày Mua", s3: "Thời Hạn Đăng Ký", s4p: "VD: 45", s5: "Đặt lại",
        s6: "Còn hiệu lực", s7: "Đã hết hạn", s8: "ngày còn lại", s9: "ngày đã qua", s10: "tổng ngày",
        s11: "Bắt đầu", s12: "Kết thúc", s13: "Lưu vào Lịch", s14: "Đã lưu",
        s16: "chọn thời hạn Tùy chỉnh & nhập số ngày",
        w1: "TẠI SAO LÀ REFUNDAJA", w2a: "Nhỏ, nhưng", w2b: "nghiêm túc.",
        w3t: "Công thức mở, không phỏng đoán",
        wfd: "Từng rupiah đều truy được. Không có con số kỳ diệu — chỉ phép tính đơn giản, minh bạch.",
        w4t: "Tức thì & theo thời gian thực", w4d: "Kết quả thay đổi ngay khi bạn gõ. Không cần nút tính.",
        w5t: "Tỷ lệ linh hoạt", w5d: "Kéo từ 10% đến 100% — theo thỏa thuận của bạn.",
        w6t: "Miễn phí & riêng tư", w6d: "Mọi phép tính đều ở trình duyệt của bạn. Không dữ liệu nào được gửi hay lưu.",
        h0: "CÁCH HOẠT ĐỘNG", ha: "Ba bước,", hb: "xong.",
        h1t: "Nhập chi tiết đăng ký", h1d: "Tên ứng dụng, giá mua và tổng thời hạn premium — VD 30 ngày.",
        h2t: "Nhập số ngày còn hiệu lực", h2d: "Còn bao nhiêu ngày trước khi đăng ký của bạn hết.",
        h3t: "Đặt tỷ lệ, xem kết quả", h3d: "Kéo tỷ lệ hoàn tiền 10%–100%, ước tính hiện ngay.",
        fa: "Câu hỏi", fb: "thường gặp.",
        q1: "Refundaja có miễn phí không?", a1: "Có — 100% miễn phí mãi mãi. Không đăng nhập, không quảng cáo, không giới hạn.",
        q2: "Cách tính hoạt động thế nào?", a2: "Giá mua chia cho tổng thời hạn ra giá trị mỗi ngày, rồi nhân với số ngày còn lại và tỷ lệ hoàn tiền.",
        q3: "Tỷ lệ hoàn tiền là gì?", a3: "Phần trăm giá trị còn lại được đồng ý hoàn — 0.70 tức 70%.",
        q4: "Dữ liệu của tôi có được lưu không?", a4: "Không. Mọi thứ chạy trong trình duyệt của bạn, không gửi gì lên máy chủ.",
        q5: "Hỗ trợ ứng dụng nào?", a5: "Mọi đăng ký premium — Netflix, Spotify, YouTube Premium, Canva và hơn thế.",
        ft1: "Máy tính hoàn tiền ứng dụng premium — tức thì, miễn phí và chính xác.",
        ft2: "© 2026 Refundaja. Làm một cách tỉ mỉ.",
        ft3: "Refundaja là công cụ ước tính độc lập, không liên kết với bất kỳ nhà cung cấp nào.",
    },
    zh: {
        n1: "计算器", n2: "使用方法", n3: "常见问题", n4: "计算退款", n5: "分享 Refundaja",
        badge: "高级应用退款计算器",
        h1a: "高级应用退款，", h1b: "精确计算到", h1c1: "每一个", h1c2: "盾。",
        sub: "输入价格、期限和剩余天数——Refundaja 即刻估算您的退款金额。免费，无需登录。",
        cta1: "立即计算退款", cta2: "查看使用方法",
        c1: "100% 免费", c2: "即时结果", c3: "无需登录",
        ke: "计算器", kt1: "您最多可以退", kt2: "多少钱？",
        kd: "一切都在您的浏览器中计算——输入时结果实时更新。",
        t1: "计算退款", t2: "计算剩余天数",
        f1: "应用名称", f1p: "例如：Netflix、Spotify…", f2: "购买价格 (Rp)",
        f2h: "输入不含手续费的基础价格。例如：支付 Rp 30.260 → 填写 Rp 30.000",
        f3: "剩余有效天数", f4: "高级总期限（天）", f5: "退款比例",
        fH: "价格", fD: "期限", fS: "剩余天数",
        r1: "退款总额", r2: "填写表单进行计算", r3: "预计退款", r4: "剩余期限",
        r5: "每日价值", r6: "服务费",
        r7: "仅为估算——非服务商最终金额。公式：(价格 ÷ 期限) × 剩余天数 × 比例。",
        s2: "购买日期", s3: "订阅期限", s4p: "例如：45", s5: "重置",
        s6: "仍然有效", s7: "已过期", s8: "天剩余", s9: "天已过", s10: "天总计",
        s11: "开始", s12: "结束", s13: "保存到日历", s14: "已保存",
        s16: "选择自定义期限并填写天数",
        w1: "为什么选择 REFUNDAJA", w2a: "小巧，但", w2b: "专业。",
        w3t: "公开公式，不靠猜测",
        wfd: "每一分盾都可追溯。没有神奇数字——只有简单透明的算术。",
        w4t: "即时 & 实时", w4d: "结果随输入即时变化，无需点击计算按钮。",
        w5t: "比例灵活", w5d: "从 10% 滑动到 100%——按您的约定调整。",
        w6t: "免费 & 私密", w6d: "所有计算都在您的浏览器中进行，不发送、不保存任何数据。",
        h0: "使用方法", ha: "三步，", hb: "搞定。",
        h1t: "填写订阅详情", h1d: "应用名称、购买价格和高级总期限——例如 30 天。",
        h2t: "输入剩余有效天数", h2d: "订阅到期前还剩多少天。",
        h3t: "设置比例，查看结果", h3d: "滑动退款比例 10%–100%，估算即刻显示。",
        fa: "常见", fb: "问题。",
        q1: "Refundaja 免费吗？", a1: "是的——100% 永久免费。无需登录、无广告、无限制。",
        q2: "计算原理是什么？", a2: "购买价格除以总期限得到每日价值，再乘以剩余天数和退款比例。",
        q3: "什么是退款比例？", a3: "约定退还的剩余价值百分比——0.70 即 70%。",
        q4: "我的数据会被保存吗？", a4: "不会。一切都在您的浏览器中运行，不会发送到任何服务器。",
        q5: "支持哪些应用？", a5: "所有高级订阅——Netflix、Spotify、YouTube Premium、Canva 等。",
        ft1: "高级应用退款计算器——即时、免费、准确。",
        ft2: "© 2026 Refundaja。用心制作。",
        ft3: "Refundaja 是独立的估算工具，与任何服务商无关。",
    },
    ja: {
        n1: "計算機", n2: "使い方", n3: "FAQ", n4: "返金を計算", n5: "Refundajaを共有",
        badge: "プレミアム返金計算機",
        h1a: "プレミアムアプリの返金を", h1b: "最後の", h1c1: "1ルピア", h1c2: "まで計算。",
        sub: "価格・期間・残り日数を入れるだけ——Refundajaが返金見込み額を即座に計算。無料、ログイン不要。",
        cta1: "今すぐ返金を計算", cta2: "使い方を見る",
        c1: "100% 無料", c2: "即時結果", c3: "ログイン不要",
        ke: "計算機", kt1: "いくら", kt2: "戻ってくる？",
        kd: "すべてブラウザ内で計算——入力するたびに結果が更新されます。",
        t1: "返金を計算", t2: "残り日数を計算",
        f1: "アプリ名", f1p: "例：Netflix, Spotify…", f2: "購入価格 (Rp)",
        f2h: "手数料抜きの基本価格を入力。例：Rp 30.260支払い → Rp 30.000と入力",
        f3: "残り有効日数", f4: "プレミアム総期間（日）", f5: "返金レート",
        fH: "価格", fD: "期間", fS: "残り日数",
        r1: "返金合計", r2: "フォームに入力して計算", r3: "返金見込み額", r4: "残り期間",
        r5: "1日あたりの価値", r6: "サービス料",
        r7: "見積もり——提供元の最終金額ではありません。計算式：(価格 ÷ 期間) × 残り日数 × レート。",
        s2: "購入日", s3: "契約期間", s4p: "例：45", s5: "リセット",
        s6: "有効中", s7: "期限切れ", s8: "日残り", s9: "日経過", s10: "日 合計",
        s11: "開始", s12: "終了", s13: "カレンダーに保存", s14: "保存しました",
        s16: "カスタム期間を選んで日数を入力",
        w1: "なぜ REFUNDAJA", w2a: "小さい、でも", w2b: "本格派。",
        w3t: "公開された計算式、勘違いなし",
        wfd: "すべてのルピアを追跡可能。不思議な数字はなし——透明でシンプルな計算のみ。",
        w4t: "即時 & リアルタイム", w4d: "入力するだけで結果が変化。計算ボタン不要。",
        w5t: "柔軟なレート", w5d: "10%から100%までスライド——あなたの取り決めに合わせて。",
        w6t: "無料 & プライベート", w6d: "すべての計算はブラウザ内。データの送信・保存は一切なし。",
        h0: "使い方", ha: "3ステップ、", hb: "完了。",
        h1t: "契約の詳細を入力", h1d: "アプリ名・購入価格・総期間——例：30日。",
        h2t: "残り有効日数を入力", h2d: "契約が終わるまであと何日あるか。",
        h3t: "レートを設定して結果を見る", h3d: "返金レートを10%–100%で動かすと見積もりが表示。",
        fa: "よくある", fb: "質問。",
        q1: "Refundajaは無料？", a1: "はい——100%永久無料。ログイン不要、広告なし、制限なし。",
        q2: "計算の仕組みは？", a2: "購入価格を総期間で割って1日あたりの価値を出し、残り日数と返金レートを掛けます。",
        q3: "返金レートとは？", a3: "返金が合意された残り価値の割合——0.70は70%を意味します。",
        q4: "データは保存されますか？", a4: "いいえ。すべてブラウザ内で動作し、サーバーには何も送信されません。",
        q5: "対応アプリは？", a5: "すべてのプレミアム契約——Netflix、Spotify、YouTube Premium、Canvaなど。",
        ft1: "プレミアムアプリ返金計算機——即時・無料・正確。",
        ft2: "© 2026 Refundaja。丁寧に作られています。",
        ft3: "Refundajaは独立した見積もりツールであり、いかなる提供者とも提携していません。",
    },
    ko: {
        n1: "계산기", n2: "이용 방법", n3: "FAQ", n4: "환불 계산", n5: "Refundaja 공유",
        badge: "프리미엄 환불 계산기",
        h1a: "프리미엄 앱 환불,", h1b: "마지막", h1c1: "루피아까지", h1c2: "정확하게.",
        sub: "가격, 기간, 남은 일수를 입력하세요 — Refundaja가 환불 예상액을 즉시 계산합니다. 무료, 로그인 불필요.",
        cta1: "지금 환불 계산", cta2: "이용 방법 보기",
        c1: "100% 무료", c2: "즉시 결과", c3: "로그인 불필요",
        ke: "계산기", kt1: "얼마나", kt2: "돌려받을 수 있을까요?",
        kd: "모든 계산은 브라우저에서 즉시 — 입력할 때마다 결과가 바뀝니다.",
        t1: "환불 계산", t2: "남은 일수 계산",
        f1: "앱 이름", f1p: "예: Netflix, Spotify…", f2: "구매 가격 (Rp)",
        f2h: "수수료 제외 기본 가격 입력. 예: Rp 30.260 결제 → Rp 30.000 입력",
        f3: "남은 유효 일수", f4: "총 프리미엄 기간 (일)", f5: "환불 비율",
        fH: "가격", fD: "기간", fS: "남은 일수",
        r1: "환불 총액", r2: "양식을 입력해 계산", r3: "환불 예상액", r4: "남은 기간",
        r5: "일일 가치", r6: "서비스 수수료",
        r7: "예상치 — 제공사 최종 금액 아님. 공식: (가격 ÷ 기간) × 남은 일수 × 비율.",
        s2: "구매 날짜", s3: "구독 기간", s4p: "예: 45", s5: "초기화",
        s6: "아직 유효", s7: "만료됨", s8: "일 남음", s9: "일 경과", s10: "일 총",
        s11: "시작", s12: "종료", s13: "캘린더에 저장", s14: "저장됨",
        s16: "사용자 지정 기간을 선택하고 일수 입력",
        w1: "왜 REFUNDAJA인가", w2a: "작지만", w2b: "진지하게.",
        w3t: "공개된 공식, 추측 없음",
        wfd: "모든 루피아를 추적 가능. 마법 같은 숫자 없이 — 간단하고 투명한 산술뿐.",
        w4t: "즉시 & 실시간", w4d: "입력하는 즉시 결과 변경. 계산 버튼 불필요.",
        w5t: "유연한 비율", w5d: "10%에서 100%까지 슬라이드 — 합의에 맞게.",
        w6t: "무료 & 비공개", w6d: "모든 계산은 브라우저에서. 데이터 전송·저장 없음.",
        h0: "이용 방법", ha: "세 단계,", hb: "끝.",
        h1t: "구독 정보 입력", h1d: "앱 이름, 구매 가격, 총 프리미엄 기간 — 예: 30일.",
        h2t: "남은 유효 일수 입력", h2d: "구독 만료까지 며칠 남았는지.",
        h3t: "비율 설정, 결과 확인", h3d: "환불 비율 10%–100% 슬라이드하면 예상액 표시.",
        fa: "자주 묻는", fb: "질문.",
        q1: "Refundaja는 무료인가요?", a1: "네 — 100% 영구 무료. 로그인, 광고, 제한 없음.",
        q2: "계산 원리는?", a2: "구매 가격을 총 기간으로 나눠 일일 가치를 구한 뒤 남은 일수와 환불 비율을 곱합니다.",
        q3: "환불 비율이란?", a3: "환불하기로 합의한 남은 가치의 백분율 — 0.70은 70%입니다.",
        q4: "내 데이터가 저장되나요?", a4: "아니요. 모든 것이 브라우저에서 실행되며 서버로 전송되지 않습니다.",
        q5: "어떤 앱을 지원하나요?", a5: "모든 프리미엄 구독 — Netflix, Spotify, YouTube Premium, Canva 등.",
        ft1: "프리미엄 앱 환불 계산기 — 즉시, 무료, 정확.",
        ft2: "© 2026 Refundaja. 정성껏 만들었습니다.",
        ft3: "Refundaja는 독립적인 예상 도구로 어떤 제공사와도 무관합니다.",
    },
    hi: {
        n1: "कैलकुलेटर", n2: "कैसे काम करता है", n3: "FAQ", n4: "रिफंड गणना", n5: "Refundaja साझा करें",
        badge: "प्रीमियम रिफंड कैलकुलेटर",
        h1a: "प्रीमियम ऐप रिफंड,", h1b: "आखिरी", h1c1: "रुपिया", h1c2: "तक गिना।",
        sub: "कीमत, अवधि और बचे दिन डालें — Refundaja आपका पैसा वापसी का अनुमान तुरंत निकालता है। मुफ़्त, बिना लॉगिन।",
        cta1: "अभी रिफंड गणना करें", cta2: "काम करने का तरीका देखें",
        c1: "100% मुफ़्त", c2: "तुरंत परिणाम", c3: "बिना लॉगिन",
        ke: "कैलकुलेटर", kt1: "आप कितना", kt2: "वापस पा सकते हैं?",
        kd: "सब कुछ आपके ब्राउज़र में गणना — टाइप करते ही परिणाम बदलता है।",
        t1: "रिफंड गणना", t2: "बचे दिन गणना",
        f1: "ऐप का नाम", f1p: "जैसे: Netflix, Spotify…", f2: "खरीद कीमत (Rp)",
        f2h: "एडमिन शुल्क के बिना बेस कीमत डालें। जैसे: Rp 30.260 भुगतान → Rp 30.000 लिखें",
        f3: "बचे सक्रिय दिन", f4: "कुल प्रीमियम अवधि (दिन)", f5: "रिफंड दर",
        fH: "कीमत", fD: "अवधि", fS: "बचे दिन",
        r1: "कुल रिफंड", r2: "गणना के लिए फॉर्म भरें", r3: "अनुमानित रिफंड", r4: "बची अवधि",
        r5: "प्रति दिन मूल्य", r6: "सेवा शुल्क",
        r7: "अनुमान — प्रदाता का अंतिम आंकड़ा नहीं। सूत्र: (कीमत ÷ अवधि) × बचे दिन × दर।",
        s2: "खरीद तिथि", s3: "सदस्यता अवधि", s4p: "जैसे: 45", s5: "रीसेट",
        s6: "अभी सक्रिय", s7: "समाप्त", s8: "दिन बचे", s9: "दिन बीते", s10: "कुल दिन",
        s11: "शुरू", s12: "समाप्ति", s13: "कैलेंडर में सहेजें", s14: "सहेजा गया",
        s16: "कस्टम अवधि चुनें और दिन भरें",
        w1: "REFUNDAJA क्यों", w2a: "छोटा, पर", w2b: "गंभीर।",
        w3t: "खुला सूत्र, कोई अंदाज़ा नहीं",
        wfd: "हर रुपिया ट्रेस करें। कोई जादुई अंक नहीं — बस सरल पारदर्शी गणित।",
        w4t: "तुरंत & रीयल-टाइम", w4d: "टाइप करते ही परिणाम बदलता है। कोई बटन नहीं।",
        w5t: "लचीली दर", w5d: "10% से 100% तक स्लाइड — अपने समझौते के अनुसार।",
        w6t: "मुफ़्त & निजी", w6d: "सभी गणनाएं आपके ब्राउज़र में। कोई डेटा भेजा या सहेजा नहीं जाता।",
        h0: "कैसे काम करता है", ha: "तीन कदम,", hb: "बस।",
        h1t: "सदस्यता विवरण भरें", h1d: "ऐप नाम, खरीद कीमत और कुल प्रीमियम अवधि — जैसे 30 दिन।",
        h2t: "बचे सक्रिय दिन डालें", h2d: "सदस्यता खत्म होने से पहले कितने दिन बचे हैं।",
        h3t: "दर सेट करें, परिणाम देखें", h3d: "रिफंड दर 10%–100% स्लाइड करें, अनुमान तुरंत दिखेगा।",
        fa: "अक्सर पूछे", fb: "जाने वाले।",
        q1: "क्या Refundaja मुफ़्त है?", a1: "हां — 100% हमेशा मुफ़्त। कोई लॉगिन, विज्ञापन या सीमा नहीं।",
        q2: "गणना कैसे होती है?", a2: "खरीद कीमत को कुल अवधि से भाग देकर दैनिक मूल्य निकाला जाता है, फिर बचे दिन और दर से गुणा।",
        q3: "रिफंड दर क्या है?", a3: "बचे मूल्य का प्रतिशत जो लौटाने पर सहमति है — 0.70 यानी 70%।",
        q4: "क्या मेरा डेटा सहेजा जाता है?", a4: "नहीं। सब आपके ब्राउज़र में चलता है, सर्वर को कुछ नहीं भेजा जाता।",
        q5: "कौन से ऐप समर्थित हैं?", a5: "सभी प्रीमियम सदस्यताएं — Netflix, Spotify, YouTube Premium, Canva आदि।",
        ft1: "प्रीमियम ऐप रिफंड कैलकुलेटर — तुरंत, मुफ़्त और सटीक।",
        ft2: "© 2026 Refundaja। सावधानी से बनाया गया।",
        ft3: "Refundaja एक स्वतंत्र अनुमान टूल है, किसी भी प्रदाता से संबद्ध नहीं।",
    },
    bn: {
        n1: "ক্যালকুলেটর", n2: "কীভাবে কাজ করে", n3: "FAQ", n4: "রিফান্ড হিসাব", n5: "Refundaja শেয়ার করুন",
        badge: "প্রিমিয়াম রিফান্ড ক্যালকুলেটর",
        h1a: "প্রিমিয়াম অ্যাপ রিফান্ড,", h1b: "শেষ", h1c1: "রুপিয়া", h1c2: "পর্যন্ত হিসাব।",
        sub: "দাম, মেয়াদ ও বাকি দিন দিন — Refundaja আপনার ফেরতের হিসাব নিমেষেই বের করে। ফ্রি, লগইন ছাড়া।",
        cta1: "এখনই রিফান্ড হিসাব করুন", cta2: "কীভাবে কাজ করে দেখুন",
        c1: "১০০% ফ্রি", c2: "তাৎক্ষণিক ফলাফল", c3: "লগইন ছাড়া",
        ke: "ক্যালকুলেটর", kt1: "আপনি কত", kt2: "ফেরত পাবেন?",
        kd: "সব হিসাব আপনার ব্রাউজারেই — টাইপ করার সাথে সাথে ফল বদলায়।",
        t1: "রিফান্ড হিসাব", t2: "বাকি দিন হিসাব",
        f1: "অ্যাপের নাম", f1p: "যেমন: Netflix, Spotify…", f2: "কেনার দাম (Rp)",
        f2h: "অ্যাডমিন ফি ছাড়া মূল দাম দিন। যেমন: Rp 30.260 দিলে → Rp 30.000 লিখুন",
        f3: "বাকি সক্রিয় দিন", f4: "মোট প্রিমিয়াম মেয়াদ (দিন)", f5: "রিফান্ড হার",
        fH: "দাম", fD: "মেয়াদ", fS: "বাকি দিন",
        r1: "মোট রিফান্ড", r2: "হিসাব করতে ফর্ম পূরণ করুন", r3: "আনুমানিক রিফান্ড", r4: "বাকি মেয়াদ",
        r5: "দৈনিক মূল্য", r6: "সার্ভিস ফি",
        r7: "আনুমানিক — প্রদানকারীর চূড়ান্ত সংখ্যা নয়। সূত্র: (দাম ÷ মেয়াদ) × বাকি দিন × হার।",
        s2: "কেনার তারিখ", s3: "সাবস্ক্রিপশন মেয়াদ", s4p: "যেমন: 45", s5: "রিসেট",
        s6: "এখনও সক্রিয়", s7: "মেয়াদোত্তীর্ণ", s8: "দিন বাকি", s9: "দিন অতিবাহিত", s10: "মোট দিন",
        s11: "শুরু", s12: "শেষ", s13: "ক্যালেন্ডারে সংরক্ষণ", s14: "সংরক্ষিত",
        s16: "কাস্টম মেয়াদ বেছে দিনের সংখ্যা দিন",
        w1: "কেন REFUNDAJA", w2a: "ছোট, কিন্তু", w2b: "সিরিয়াস।",
        w3t: "খোলা সূত্র, অনুমান নয়",
        wfd: "প্রতিটি রুপিয়া ট্রেস করা যায়। কোনো জাদুর সংখ্যা নেই — শুধু সরল স্বচ্ছ অঙ্ক।",
        w4t: "তাৎক্ষণিক ও রিয়েল-টাইম", w4d: "টাইপ করলেই ফল বদলে যায়। কোনো বোতাম লাগে না।",
        w5t: "নমনীয় হার", w5d: "১০% থেকে ১০০% পর্যন্ত স্লাইড — আপনার সমঝোতা অনুযায়ী।",
        w6t: "ফ্রি ও ব্যক্তিগত", w6d: "সব হিসাব আপনার ব্রাউজারে। কোনো ডেটা পাঠানো বা জমা হয় না।",
        h0: "কীভাবে কাজ করে", ha: "তিন ধাপ,", hb: "শেষ।",
        h1t: "সাবস্ক্রিপশনের বিবরণ দিন", h1d: "অ্যাপের নাম, কেনার দাম ও মোট প্রিমিয়াম মেয়াদ — যেমন ৩০ দিন।",
        h2t: "বাকি সক্রিয় দিন দিন", h2d: "সাবস্ক্রিপশন শেষ হওয়ার আগে আর কয়দিন বাকি।",
        h3t: "হার নির্ধারণ, ফল দেখুন", h3d: "রিফান্ড হার ১০%–১০০% স্লাইড করুন, হিসাব সঙ্গে সঙ্গে দেখাবে।",
        fa: "প্রায়শই জিজ্ঞাসিত", fb: "প্রশ্ন।",
        q1: "Refundaja কি ফ্রি?", a1: "হ্যাঁ — ১০০% চিরদিনের জন্য ফ্রি। লগইন, বিজ্ঞাপন বা সীমা নেই।",
        q2: "হিসাব কীভাবে হয়?", a2: "কেনার দামকে মোট মেয়াদ দিয়ে ভাগ করে দৈনিক মূল্য বের করা হয়, তারপর বাকি দিন ও হার দিয়ে গুণ।",
        q3: "রিফান্ড হার কী?", a3: "ফেরত দেওয়ার সম্মত বাকি মূল্যের শতাংশ — ০.৭০ মানে ৭০%।",
        q4: "আমার ডেটা কি সংরক্ষিত হয়?", a4: "না। সবই আপনার ব্রাউজারে চলে, সার্ভারে কিছু পাঠানো হয় না।",
        q5: "কোন অ্যাপ সমর্থিত?", a5: "সব প্রিমিয়াম সাবস্ক্রিপশন — Netflix, Spotify, YouTube Premium, Canva ইত্যাদি।",
        ft1: "প্রিমিয়াম অ্যাপ রিফান্ড ক্যালকুলেটর — তাৎক্ষণিক, ফ্রি ও নির্ভুল।",
        ft2: "© 2026 Refundaja। যত্নে তৈরি।",
        ft3: "Refundaja একটি স্বাধীন অনুমান টুল, কোনো প্রদানকারীর সাথে যুক্ত নয়।",
    },
    ur: {
        n1: "کیلکولیٹر", n2: "طریقہ کار", n3: "عمومی سوالات", n4: "ریفنڈ شمار کریں", n5: "Refundaja شیئر کریں",
        badge: "پریمیم ریفنڈ کیلکولیٹر",
        h1a: "پریمیم ایپ ریفنڈ،", h1b: "آخری", h1c1: "روپیہ", h1c2: "تک شمار۔",
        sub: "قیمت، مدت اور باقی دن درج کریں — Refundaja آپ کی واپسی کا اندازہ فوری نکالتا ہے۔ مفت، بغیر لاگ اِن۔",
        cta1: "ابھی ریفنڈ شمار کریں", cta2: "طریقہ کار دیکھیں",
        c1: "100% مفت", c2: "فوری نتیجہ", c3: "بغیر لاگ اِن",
        ke: "کیلکولیٹر", kt1: "آپ کتنا", kt2: "واپس لے سکتے ہیں؟",
        kd: "سب کچھ آپ کے براؤزر میں شمار — لکھتے ہی نتیجہ بدلتا ہے۔",
        t1: "ریفنڈ شمار کریں", t2: "باقی دن شمار کریں",
        f1: "ایپ کا نام", f1p: "مثلاً: Netflix، Spotify…", f2: "خرید کی قیمت (Rp)",
        f2h: "ایڈمن فیس کے بغیر بنیادی قیمت درج کریں۔ مثلاً: Rp 30.260 ادا → Rp 30.000 لکھیں",
        f3: "باقی فعال دن", f4: "کل پریمیم مدت (دن)", f5: "ریفنڈ شرح",
        fH: "قیمت", fD: "مدت", fS: "باقی دن",
        r1: "کل ریفنڈ", r2: "شمار کے لیے فارم پُر کریں", r3: "تخمینی ریفنڈ", r4: "باقی مدت",
        r5: "فی دن قیمت", r6: "سروس فیس",
        r7: "تخمینہ — فراہم کنندہ کی حتمی رقم نہیں۔ فارمولا: (قیمت ÷ مدت) × باقی دن × شرح۔",
        s2: "خرید کی تاریخ", s3: "سبسکرپشن مدت", s4p: "مثلاً: 45", s5: "ری سیٹ",
        s6: "ابھی فعال", s7: "ختم شدہ", s8: "دن باقی", s9: "دن گزرے", s10: "کل دن",
        s11: "آغاز", s12: "اختتام", s13: "کیلنڈر میں محفوظ کریں", s14: "محفوظ ہو گیا",
        s16: "کسٹم مدت منتخب کریں اور دن درج کریں",
        w1: "REFUNDAJA کیوں", w2a: "چھوٹا، مگر", w2b: "سنجیدہ۔",
        w3t: "کھلا فارمولا، اندازہ نہیں",
        wfd: "ہر روپیہ ٹریس ہو سکتا ہے۔ کوئی جادوئی عدد نہیں — بس سادہ شفاف حساب۔",
        w4t: "فوری اور حقیقی وقت", w4d: "لکھتے ہی نتیجہ بدلتا ہے۔ بٹن کی ضرورت نہیں۔",
        w5t: "لچکدار شرح", w5d: "10% سے 100% تک سلائیڈ — اپنے معاہدے کے مطابق۔",
        w6t: "مفت اور نجی", w6d: "سب حساب آپ کے براؤزر میں۔ کوئی ڈیٹا نہ بھیجا نہ محفوظ ہوتا۔",
        h0: "طریقہ کار", ha: "تین قدم،", hb: "بس۔",
        h1t: "سبسکرپشن کی تفصیل لکھیں", h1d: "ایپ کا نام، خرید قیمت اور کل پریمیم مدت — مثلاً 30 دن۔",
        h2t: "باقی فعال دن درج کریں", h2d: "سبسکرپشن ختم ہونے سے پہلے کتنے دن باقی ہیں۔",
        h3t: "شرح سیٹ کریں، نتیجہ دیکھیں", h3d: "ریفنڈ شرح 10%–100% سلائیڈ کریں، اندازہ فوراً ظاہر ہوگا۔",
        fa: "اکثر پوچھے", fb: "جانے والے۔",
        q1: "کیا Refundaja مفت ہے؟", a1: "جی ہاں — 100% ہمیشہ کے لیے مفت۔ نہ لاگ اِن، نہ اشتہار، نہ حد۔",
        q2: "شمار کیسے ہوتا ہے؟", a2: "خرید قیمت کو کل مدت پر تقسیم کر کے روزانہ قیمت نکلتی ہے، پھر باقی دن اور شرح سے ضرب۔",
        q3: "ریفنڈ شرح کیا ہے؟", a3: "واپسی پر متفقہ باقی قیمت کا فیصد — 0.70 یعنی 70%۔",
        q4: "کیا میرا ڈیٹا محفوظ ہوتا ہے؟", a4: "نہیں۔ سب آپ کے براؤزر میں چلتا ہے، سرور کو کچھ نہیں بھیجا جاتا۔",
        q5: "کون سی ایپس سپورٹڈ ہیں؟", a5: "ہر پریمیم سبسکرپشن — Netflix، Spotify، YouTube Premium، Canva وغیرہ۔",
        ft1: "پریمیم ایپ ریفنڈ کیلکولیٹر — فوری، مفت اور درست۔",
        ft2: "© 2026 Refundaja۔ محبت سے بنایا گیا۔",
        ft3: "Refundaja ایک آزاد تخمینی ٹول ہے، کسی بھی فراہم کنندہ سے وابستہ نہیں۔",
    },
    ar: {
        n1: "الحاسبة", n2: "كيف تعمل", n3: "الأسئلة الشائعة", n4: "احسب الاسترداد", n5: "شارك Refundaja",
        badge: "حاسبة استرداد الاشتراكات المميزة",
        h1a: "استرداد التطبيقات", h1b: "المميزة، محسوب", h1c1: "حتى آخر", h1c2: "روبية.",
        sub: "أدخل السعر والمدة والأيام المتبقية — يحسب Refundaja المبلغ المتوقع استرداده في لحظة. مجاني، بدون تسجيل دخول.",
        cta1: "احسب الاسترداد الآن", cta2: "شاهد كيف تعمل",
        c1: "مجاني 100%", c2: "نتائج فورية", c3: "بدون تسجيل دخول",
        ke: "الحاسبة", kt1: "كم يمكنك", kt2: "استرداده؟",
        kd: "كل شيء يُحسب في متصفحك مباشرة — تتغير النتيجة فور الكتابة.",
        t1: "احسب الاسترداد", t2: "احسب الأيام المتبقية",
        f1: "اسم التطبيق", f1p: "مثال: Netflix، Spotify…", f2: "سعر الشراء (Rp)",
        f2h: "أدخل السعر الأساسي بدون رسوم إدارية. مثال: دفعت Rp 30.260 ← اكتب Rp 30.000",
        f3: "الأيام النشطة المتبقية", f4: "إجمالي مدة الاشتراك (أيام)", f5: "معدل الاسترداد",
        fH: "السعر", fD: "المدة", fS: "الأيام المتبقية",
        r1: "إجمالي الاسترداد", r2: "املأ النموذج للحساب", r3: "الاسترداد التقديري", r4: "المدة المتبقية",
        r5: "القيمة اليومية", r6: "رسوم الخدمة",
        r7: "تقدير — ليس الرقم النهائي من مزود الخدمة. المعادلة: (السعر ÷ المدة) × الأيام المتبقية × المعدل.",
        s2: "تاريخ الشراء", s3: "مدة الاشتراك", s4p: "مثال: 45", s5: "إعادة تعيين",
        s6: "ما زال نشطاً", s7: "منتهي الصلاحية", s8: "يوم متبقٍ", s9: "يوم مضى", s10: "يوم إجمالي",
        s11: "البداية", s12: "النهاية", s13: "حفظ في التقويم", s14: "تم الحفظ",
        s16: "اختر مدة مخصصة وأدخل عدد الأيام",
        w1: "لماذا REFUNDAJA", w2a: "صغير، لكن", w2b: "جاد.",
        w3t: "معادلة مفتوحة، بلا تخمين",
        wfd: "كل روبية قابلة للتتبع. لا أرقام سحرية — فقط حساب بسيط وشفاف.",
        w4t: "فوري ولحظي", w4d: "تتغير النتيجة فور الكتابة. لا حاجة لزر حساب.",
        w5t: "معدل مرن", w5d: "حرّك من 10% إلى 100% — حسب اتفاقك.",
        w6t: "مجاني وخاص", w6d: "كل الحسابات تتم في متصفحك. لا بيانات تُرسل أو تُخزَّن.",
        h0: "كيف تعمل", ha: "ثلاث خطوات،", hb: "انتهى.",
        h1t: "أدخل تفاصيل الاشتراك", h1d: "اسم التطبيق وسعر الشراء وإجمالي المدة المميزة — مثلاً 30 يوماً.",
        h2t: "أدخل الأيام المتبقية", h2d: "كم يوماً بقي قبل انتهاء اشتراكك.",
        h3t: "اضبط المعدل وشاهد النتيجة", h3d: "حرّك معدل الاسترداد 10%–100% وسيظهر التقدير فوراً.",
        fa: "الأسئلة", fb: "الشائعة.",
        q1: "هل Refundaja مجاني؟", a1: "نعم — مجاني 100% ودائماً. بدون تسجيل دخول أو إعلانات أو حدود.",
        q2: "كيف يعمل الحساب؟", a2: "سعر الشراء مقسوماً على إجمالي المدة يعطي القيمة اليومية، ثم يُضرب في الأيام المتبقية ومعدل الاسترداد.",
        q3: "ما هو معدل الاسترداد؟", a3: "النسبة المئوية المتفق على إعادتها من القيمة المتبقية — 0.70 تعني 70%.",
        q4: "هل تُخزَّن بياناتي؟", a4: "لا. كل شيء يعمل في متصفحك ولا يُرسَل شيء إلى أي خادم.",
        q5: "ما التطبيقات المدعومة؟", a5: "جميع الاشتراكات المميزة — Netflix وSpotify وYouTube Premium وCanva وغيرها.",
        ft1: "حاسبة استرداد التطبيقات المميزة — فورية ومجانية ودقيقة.",
        ft2: "© 2026 Refundaja. صُنع بعناية.",
        ft3: "Refundaja أداة تقدير مستقلة وغير تابعة لأي مزود خدمة.",
    },
    tr: {
        n1: "Hesaplayıcı", n2: "Nasıl Çalışır", n3: "SSS", n4: "İade Hesapla", n5: "Refundaja'yı Paylaş",
        badge: "PREMİUM İADE HESAPLAYICI",
        h1a: "Premium uygulama", h1b: "iadesi, son", h1c1: "rupiye", h1c2: "kadar.",
        sub: "Fiyatı, süreyi ve kalan günleri girin — Refundaja iadenizi saniyeler içinde hesaplar. Ücretsiz, giriş yok.",
        cta1: "Şimdi İade Hesapla", cta2: "Nasıl Çalışır Gör",
        c1: "%100 ücretsiz", c2: "Anında sonuç", c3: "Giriş yok",
        ke: "HESAPLAYICI", kt1: "Ne kadar", kt2: "geri alabilirsin?",
        kd: "Her şey tarayıcınızda hesaplanır — yazdıkça sonuç değişir.",
        t1: "İade Hesapla", t2: "Kalan Gün Hesapla",
        f1: "Uygulama Adı", f1p: "Örn: Netflix, Spotify…", f2: "Satın Alma Fiyatı (Rp)",
        f2h: "Admin ücreti olmadan temel fiyatı girin. Örn: Rp 30.260 ödedi → Rp 30.000 yaz",
        f3: "Kalan Aktif Gün", f4: "Toplam Premium Süre (Gün)", f5: "İade Oranı",
        fH: "Fiyat", fD: "Süre", fS: "Kalan gün",
        r1: "Toplam İade", r2: "hesaplamak için formu doldur", r3: "Tahmini iade", r4: "Kalan Süre",
        r5: "Günlük değer", r6: "Servis Ücreti",
        r7: "Tahmin — sağlayıcının nihai rakamı değil. Formül: (fiyat ÷ süre) × kalan gün × oran.",
        s2: "Satın Alma Tarihi", s3: "Abonelik Süresi", s4p: "Örn: 45", s5: "Sıfırla",
        s6: "Hâlâ aktif", s7: "Süresi doldu", s8: "gün kaldı", s9: "gün geçti", s10: "toplam gün",
        s11: "Başlangıç", s12: "Bitiş", s13: "Takvime Kaydet", s14: "Kaydedildi",
        s16: "Özel süre seç ve gün sayısı gir",
        w1: "NEDEN REFUNDAJA", w2a: "Küçük ama", w2b: "ciddi.",
        w3t: "Açık formül, tahmin yok",
        wfd: "Her rupi izlenebilir. Sihirli sayı yok — sadece basit, şeffaf aritmetik.",
        w4t: "Anında & gerçek zamanlı", w4d: "Yazdıkça sonuç değişir. Hesapla düğmesi gerekmez.",
        w5t: "Esnek oran", w5d: "%10'dan %100'e kaydır — anlaşmana göre.",
        w6t: "Ücretsiz & gizli", w6d: "Tüm hesaplamalar tarayıcında. Veri gönderilmez veya saklanmaz.",
        h0: "NASIL ÇALIŞIR", ha: "Üç adım,", hb: "bitti.",
        h1t: "Abonelik detaylarını gir", h1d: "Uygulama adı, satın alma fiyatı ve toplam premium süre — örn 30 gün.",
        h2t: "Kalan aktif günleri gir", h2d: "Aboneliğin bitmeden kaç gün kaldı.",
        h3t: "Oranı ayarla, sonucu gör", h3d: "İade oranını %10–%100 kaydır, tahmin anında görünür.",
        fa: "Sıkça Sorulan", fb: "Sorular.",
        q1: "Refundaja ücretsiz mi?", a1: "Evet — %100 sonsuza kadar ücretsiz. Giriş, reklam veya limit yok.",
        q2: "Hesaplama nasıl çalışır?", a2: "Satın alma fiyatı toplam süreye bölünüp günlük değer bulunur, sonra kalan gün ve oranla çarpılır.",
        q3: "İade oranı nedir?", a3: "İadesi kabul edilen kalan değerin yüzdesi — 0.70 yani %70.",
        q4: "Verilerim saklanıyor mu?", a4: "Hayır. Her şey tarayıcında çalışır, sunucuya hiçbir şey gönderilmez.",
        q5: "Hangi uygulamalar destekleniyor?", a5: "Tüm premium abonelikler — Netflix, Spotify, YouTube Premium, Canva ve daha fazlası.",
        ft1: "Premium uygulama iade hesaplayıcısı — anında, ücretsiz ve doğru.",
        ft2: "© 2026 Refundaja. Özenle yapıldı.",
        ft3: "Refundaja bağımsız bir tahmin aracıdır, hiçbir sağlayıcıyla bağlantılı değildir.",
    },
    ru: {
        n1: "Калькулятор", n2: "Как работает", n3: "FAQ", n4: "Рассчитать возврат", n5: "Поделиться Refundaja",
        badge: "КАЛЬКУЛЯТОР ВОЗВРАТА ПРЕМИУМ",
        h1a: "Возврат премиум-", h1b: "приложений, до", h1c1: "последней", h1c2: "рупии.",
        sub: "Введите цену, срок и оставшиеся дни — Refundaja мгновенно оценит возврат. Бесплатно, без входа.",
        cta1: "Рассчитать возврат", cta2: "Как это работает",
        c1: "100% бесплатно", c2: "Мгновенный результат", c3: "Без входа",
        ke: "КАЛЬКУЛЯТОР", kt1: "Сколько вы можете", kt2: "вернуть?",
        kd: "Всё считается прямо в браузере — результат меняется по мере ввода.",
        t1: "Рассчитать возврат", t2: "Оставшиеся дни",
        f1: "Название приложения", f1p: "Например: Netflix, Spotify…", f2: "Цена покупки (Rp)",
        f2h: "Введите базовую цену без комиссии. Например: оплата Rp 30.260 → пишите Rp 30.000",
        f3: "Оставшиеся активные дни", f4: "Общий премиум-срок (дней)", f5: "Ставка возврата",
        fH: "Цена", fD: "Срок", fS: "Остаток дней",
        r1: "Итого возврат", r2: "заполните форму для расчёта", r3: "Оценка возврата", r4: "Оставшийся срок",
        r5: "Стоимость в день", r6: "Сервисный сбор",
        r7: "Оценка — не итоговая сумма провайдера. Формула: (цена ÷ срок) × остаток дней × ставка.",
        s2: "Дата покупки", s3: "Срок подписки", s4p: "Например: 45", s5: "Сброс",
        s6: "Ещё активна", s7: "Истекла", s8: "дней осталось", s9: "дней прошло", s10: "дней всего",
        s11: "Начало", s12: "Конец", s13: "Сохранить в календарь", s14: "Сохранено",
        s16: "выберите свой срок и введите дни",
        w1: "ПОЧЕМУ REFUNDAJA", w2a: "Маленькая, но", w2b: "серьёзная.",
        w3t: "Открытая формула, без гаданий",
        wfd: "Каждую рупию можно проследить. Никаких магических цифр — только простая прозрачная арифметика.",
        w4t: "Мгновенно и в реальном времени", w4d: "Результат меняется прямо при вводе. Кнопка не нужна.",
        w5t: "Гибкая ставка", w5d: "От 10% до 100% — под вашу договорённость.",
        w6t: "Бесплатно и приватно", w6d: "Все вычисления в вашем браузере. Данные никуда не отправляются.",
        h0: "КАК РАБОТАЕТ", ha: "Три шага,", hb: "готово.",
        h1t: "Введите данные подписки", h1d: "Название приложения, цена покупки и общий срок — например 30 дней.",
        h2t: "Укажите оставшиеся дни", h2d: "Сколько дней осталось до конца подписки.",
        h3t: "Настройте ставку и смотрите", h3d: "Двигайте ставку возврата 10%–100%, оценка появится сразу.",
        fa: "Часто задаваемые", fb: "вопросы.",
        q1: "Refundaja бесплатна?", a1: "Да — 100% навсегда бесплатно. Без входа, рекламы и лимитов.",
        q2: "Как работает расчёт?", a2: "Цена покупки делится на общий срок — получается цена дня, затем умножается на остаток дней и ставку.",
        q3: "Что такое ставка возврата?", a3: "Процент оставшейся стоимости, который согласован к возврату — 0.70 это 70%.",
        q4: "Сохраняются ли мои данные?", a4: "Нет. Всё работает в браузере, ничего не отправляется на сервер.",
        q5: "Какие приложения поддерживаются?", a5: "Любые премиум-подписки — Netflix, Spotify, YouTube Premium, Canva и другие.",
        ft1: "Калькулятор возврата премиум-приложений — мгновенно, бесплатно, точно.",
        ft2: "© 2026 Refundaja. Сделано с заботой.",
        ft3: "Refundaja — независимый инструмент оценки, не связан ни с одним провайдером.",
    },
    es: {
        n1: "Calculadora", n2: "Cómo funciona", n3: "FAQ", n4: "Calcular reembolso", n5: "Compartir Refundaja",
        badge: "CALCULADORA DE REEMBOLSO PREMIUM",
        h1a: "Reembolso de apps", h1b: "premium, calculado", h1c1: "hasta la última", h1c2: "rupia.",
        sub: "Ingresa precio, duración y días restantes — Refundaja estima tu devolución al instante. Gratis, sin registro.",
        cta1: "Calcular mi reembolso", cta2: "Ver cómo funciona",
        c1: "100% gratis", c2: "Resultado instantáneo", c3: "Sin registro",
        ke: "CALCULADORA", kt1: "¿Cuánto puedes", kt2: "recuperar?",
        kd: "Todo se calcula en tu navegador — el resultado cambia mientras escribes.",
        t1: "Calcular Reembolso", t2: "Días Restantes",
        f1: "Nombre de la app", f1p: "Ej: Netflix, Spotify…", f2: "Precio de compra (Rp)",
        f2h: "Ingresa el precio base sin cargos. Ej: pagaste Rp 30.260 → escribe Rp 30.000",
        f3: "Días activos restantes", f4: "Duración total premium (días)", f5: "Tasa de reembolso",
        fH: "Precio", fD: "Duración", fS: "Días restantes",
        r1: "Reembolso total", r2: "completa el formulario", r3: "Reembolso estimado", r4: "Duración restante",
        r5: "Valor por día", r6: "Tarifa de servicio",
        r7: "Estimación — no es la cifra final del proveedor. Fórmula: (precio ÷ duración) × días restantes × tasa.",
        s2: "Fecha de compra", s3: "Duración de suscripción", s4p: "Ej: 45", s5: "Reiniciar",
        s6: "Aún activa", s7: "Caducada", s8: "días restantes", s9: "días pasados", s10: "días totales",
        s11: "Inicio", s12: "Fin", s13: "Guardar en calendario", s14: "Guardado",
        s16: "elige duración personalizada e ingresa días",
        w1: "POR QUÉ REFUNDAJA", w2a: "Pequeña, pero", w2b: "seria.",
        w3t: "Fórmula abierta, sin adivinar",
        wfd: "Cada rupia es trazable. Sin números mágicos — solo aritmética simple y transparente.",
        w4t: "Instantáneo y en tiempo real", w4d: "El resultado cambia al escribir. Sin botón de calcular.",
        w5t: "Tasa flexible", w5d: "Desliza del 10% al 100% — según tu acuerdo.",
        w6t: "Gratis y privada", w6d: "Todo se calcula en tu navegador. No se envían ni guardan datos.",
        h0: "CÓMO FUNCIONA", ha: "Tres pasos,", hb: "listo.",
        h1t: "Ingresa los datos de la suscripción", h1d: "Nombre de la app, precio de compra y duración total — ej. 30 días.",
        h2t: "Agrega los días restantes", h2d: "Cuántos días quedan antes de que termine tu suscripción.",
        h3t: "Ajusta la tasa y mira", h3d: "Desliza la tasa 10%–100% y tu estimación aparece al instante.",
        fa: "Preguntas", fb: "frecuentes.",
        q1: "¿Refundaja es gratis?", a1: "Sí — 100% gratis para siempre. Sin registro, anuncios ni límites.",
        q2: "¿Cómo funciona el cálculo?", a2: "El precio se divide por la duración total para obtener el valor diario, luego se multiplica por días restantes y tasa.",
        q3: "¿Qué es la tasa de reembolso?", a3: "El porcentaje del valor restante acordado para devolver — 0.70 significa 70%.",
        q4: "¿Se guardan mis datos?", a4: "No. Todo corre en tu navegador y nada se envía a ningún servidor.",
        q5: "¿Qué apps son compatibles?", a5: "Cualquier suscripción premium — Netflix, Spotify, YouTube Premium, Canva y más.",
        ft1: "Calculadora de reembolso de apps premium — instantánea, gratuita y precisa.",
        ft2: "© 2026 Refundaja. Hecha con cuidado.",
        ft3: "Refundaja es una herramienta de estimación independiente, sin afiliación con ningún proveedor.",
    },
    pt: {
        n1: "Calculadora", n2: "Como funciona", n3: "FAQ", n4: "Calcular reembolso", n5: "Compartilhar Refundaja",
        badge: "CALCULADORA DE REEMBOLSO PREMIUM",
        h1a: "Reembolso de apps", h1b: "premium, calculado", h1c1: "até a última", h1c2: "rupia.",
        sub: "Insira preço, duração e dias restantes — a Refundaja estima sua devolução em segundos. Grátis, sem login.",
        cta1: "Calcular meu reembolso", cta2: "Ver como funciona",
        c1: "100% grátis", c2: "Resultado instantâneo", c3: "Sem login",
        ke: "CALCULADORA", kt1: "Quanto você pode", kt2: "recuperar?",
        kd: "Tudo é calculado no seu navegador — o resultado muda enquanto você digita.",
        t1: "Calcular Reembolso", t2: "Dias Restantes",
        f1: "Nome do app", f1p: "Ex: Netflix, Spotify…", f2: "Preço de compra (Rp)",
        f2h: "Insira o preço base sem taxas. Ex: pagou Rp 30.260 → escreva Rp 30.000",
        f3: "Dias ativos restantes", f4: "Duração total premium (dias)", f5: "Taxa de reembolso",
        fH: "Preço", fD: "Duração", fS: "Dias restantes",
        r1: "Reembolso total", r2: "preencha o formulário", r3: "Reembolso estimado", r4: "Duração restante",
        r5: "Valor por dia", r6: "Taxa de serviço",
        r7: "Estimativa — não é o valor final do provedor. Fórmula: (preço ÷ duração) × dias restantes × taxa.",
        s2: "Data de compra", s3: "Duração da assinatura", s4p: "Ex: 45", s5: "Redefinir",
        s6: "Ainda ativa", s7: "Expirada", s8: "dias restantes", s9: "dias passados", s10: "dias totais",
        s11: "Início", s12: "Fim", s13: "Salvar no calendário", s14: "Salvo",
        s16: "escolha duração personalizada e insira os dias",
        w1: "POR QUE REFUNDAJA", w2a: "Pequena, mas", w2b: "séria.",
        w3t: "Fórmula aberta, sem adivinhação",
        wfd: "Cada rupia é rastreável. Sem números mágicos — apenas aritmética simples e transparente.",
        w4t: "Instantâneo e em tempo real", w4d: "O resultado muda enquanto você digita. Sem botão de calcular.",
        w5t: "Taxa flexível", w5d: "Deslize de 10% a 100% — conforme seu acordo.",
        w6t: "Grátis e privada", w6d: "Tudo é calculado no seu navegador. Nenhum dado enviado ou armazenado.",
        h0: "COMO FUNCIONA", ha: "Três passos,", hb: "pronto.",
        h1t: "Insira os dados da assinatura", h1d: "Nome do app, preço de compra e duração total — ex. 30 dias.",
        h2t: "Adicione os dias restantes", h2d: "Quantos dias faltam para sua assinatura acabar.",
        h3t: "Ajuste a taxa e veja", h3d: "Deslize a taxa 10%–100% e a estimativa aparece na hora.",
        fa: "Perguntas", fb: "frequentes.",
        q1: "A Refundaja é grátis?", a1: "Sim — 100% grátis para sempre. Sem login, anúncios ou limites.",
        q2: "Como funciona o cálculo?", a2: "O preço é dividido pela duração total para o valor diário, depois multiplicado pelos dias restantes e taxa.",
        q3: "O que é a taxa de reembolso?", a3: "A porcentagem do valor restante acordada para devolução — 0.70 significa 70%.",
        q4: "Meus dados são armazenados?", a4: "Não. Tudo roda no seu navegador e nada é enviado a servidores.",
        q5: "Quais apps são suportados?", a5: "Qualquer assinatura premium — Netflix, Spotify, YouTube Premium, Canva e mais.",
        ft1: "Calculadora de reembolso de apps premium — instantânea, gratuita e precisa.",
        ft2: "© 2026 Refundaja. Feita com cuidado.",
        ft3: "A Refundaja é uma ferramenta de estimativa independente, sem vínculo com nenhum provedor.",
    },
    fr: {
        n1: "Calculateur", n2: "Comment ça marche", n3: "FAQ", n4: "Calculer le remboursement", n5: "Partager Refundaja",
        badge: "CALCULATEUR DE REMBOURSEMENT PREMIUM",
        h1a: "Remboursement d'apps", h1b: "premium, calculé", h1c1: "jusqu'à la dernière", h1c2: "roupie.",
        sub: "Entrez prix, durée et jours restants — Refundaja estime votre remboursement en quelques secondes. Gratuit, sans compte.",
        cta1: "Calculer mon remboursement", cta2: "Voir le fonctionnement",
        c1: "100% gratuit", c2: "Résultat instantané", c3: "Sans compte",
        ke: "CALCULATEUR", kt1: "Combien pouvez-vous", kt2: "récupérer ?",
        kd: "Tout est calculé dans votre navigateur — le résultat change à chaque frappe.",
        t1: "Calculer le remboursement", t2: "Jours restants",
        f1: "Nom de l'application", f1p: "Ex : Netflix, Spotify…", f2: "Prix d'achat (Rp)",
        f2h: "Entrez le prix de base sans frais. Ex : payé Rp 30.260 → écrivez Rp 30.000",
        f3: "Jours actifs restants", f4: "Durée totale premium (jours)", f5: "Taux de remboursement",
        fH: "Prix", fD: "Durée", fS: "Jours restants",
        r1: "Remboursement total", r2: "remplissez le formulaire", r3: "Remboursement estimé", r4: "Durée restante",
        r5: "Valeur par jour", r6: "Frais de service",
        r7: "Estimation — pas le montant final du fournisseur. Formule : (prix ÷ durée) × jours restants × taux.",
        s2: "Date d'achat", s3: "Durée de l'abonnement", s4p: "Ex : 45", s5: "Réinitialiser",
        s6: "Toujours actif", s7: "Expiré", s8: "jours restants", s9: "jours écoulés", s10: "jours au total",
        s11: "Début", s12: "Fin", s13: "Enregistrer au calendrier", s14: "Enregistré",
        s16: "choisissez une durée personnalisée et entrez les jours",
        w1: "POURQUOI REFUNDAJA", w2a: "Petite, mais", w2b: "sérieuse.",
        w3t: "Formule ouverte, sans devinette",
        wfd: "Chaque roupie est traçable. Pas de chiffres magiques — juste une arithmétique simple et transparente.",
        w4t: "Instantané & temps réel", w4d: "Le résultat change dès que vous tapez. Pas de bouton calculer.",
        w5t: "Taux flexible", w5d: "Faites glisser de 10 % à 100 % — selon votre accord.",
        w6t: "Gratuit & privé", w6d: "Tout est calculé dans votre navigateur. Aucune donnée envoyée ou stockée.",
        h0: "COMMENT ÇA MARCHE", ha: "Trois étapes,", hb: "terminé.",
        h1t: "Entrez les détails de l'abonnement", h1d: "Nom de l'app, prix d'achat et durée totale — ex. 30 jours.",
        h2t: "Ajoutez les jours restants", h2d: "Combien de jours avant la fin de votre abonnement.",
        h3t: "Réglez le taux, voyez le résultat", h3d: "Faites glisser le taux 10 %–100 %, l'estimation s'affiche.",
        fa: "Questions", fb: "fréquentes.",
        q1: "Refundaja est-il gratuit ?", a1: "Oui — 100 % gratuit pour toujours. Sans compte, pub ni limite.",
        q2: "Comment fonctionne le calcul ?", a2: "Le prix est divisé par la durée totale pour la valeur journalière, puis multiplié par les jours restants et le taux.",
        q3: "Qu'est-ce que le taux de remboursement ?", a3: "Le pourcentage de la valeur restante convenu pour le remboursement — 0.70 signifie 70 %.",
        q4: "Mes données sont-elles stockées ?", a4: "Non. Tout s'exécute dans votre navigateur, rien n'est envoyé à un serveur.",
        q5: "Quelles apps sont prises en charge ?", a5: "Tout abonnement premium — Netflix, Spotify, YouTube Premium, Canva et plus.",
        ft1: "Calculateur de remboursement d'apps premium — instantané, gratuit et précis.",
        ft2: "© 2026 Refundaja. Conçu avec soin.",
        ft3: "Refundaja est un outil d'estimation indépendant, non affilié à aucun fournisseur.",
    },
    de: {
        n1: "Rechner", n2: "So funktioniert's", n3: "FAQ", n4: "Rückerstattung berechnen", n5: "Refundaja teilen",
        badge: "PREMIUM-RÜCKERSTATTUNGS-RECHNER",
        h1a: "Premium-App-", h1b: "Erstattung, bis zur", h1c1: "letzten", h1c2: "Rupie.",
        sub: "Preis, Laufzeit und Resttage eingeben — Refundaja schätzt deine Rückerstattung in Sekunden. Kostenlos, ohne Login.",
        cta1: "Jetzt Erstattung berechnen", cta2: "So funktioniert's",
        c1: "100% kostenlos", c2: "Sofortiges Ergebnis", c3: "Ohne Login",
        ke: "RECHNER", kt1: "Wie viel kannst du", kt2: "zurückbekommen?",
        kd: "Alles wird direkt im Browser berechnet — das Ergebnis ändert sich beim Tippen.",
        t1: "Erstattung berechnen", t2: "Resttage berechnen",
        f1: "App-Name", f1p: "Z. B. Netflix, Spotify…", f2: "Kaufpreis (Rp)",
        f2h: "Basispreis ohne Gebühren eingeben. Z. B.: Rp 30.260 bezahlt → Rp 30.000 eingeben",
        f3: "Verbleibende aktive Tage", f4: "Gesamte Premium-Laufzeit (Tage)", f5: "Erstattungsrate",
        fH: "Preis", fD: "Laufzeit", fS: "Resttage",
        r1: "Gesamte Erstattung", r2: "Formular zum Berechnen ausfüllen", r3: "Geschätzte Erstattung", r4: "Verbleibende Laufzeit",
        r5: "Wert pro Tag", r6: "Servicegebühr",
        r7: "Schätzung — keine Endsumme des Anbieters. Formel: (Preis ÷ Laufzeit) × Resttage × Rate.",
        s2: "Kaufdatum", s3: "Abo-Laufzeit", s4p: "Z. B.: 45", s5: "Zurücksetzen",
        s6: "Noch aktiv", s7: "Abgelaufen", s8: "Tage übrig", s9: "Tage vergangen", s10: "Tage gesamt",
        s11: "Start", s12: "Ende", s13: "In Kalender speichern", s14: "Gespeichert",
        s16: "Eigene Laufzeit wählen & Tage eingeben",
        w1: "WARUM REFUNDAJA", w2a: "Klein, aber", w2b: "ernsthaft.",
        w3t: "Offene Formel, kein Raten",
        wfd: "Jede Rupie ist nachvollziehbar. Keine magischen Zahlen — nur einfache, transparente Mathematik.",
        w4t: "Sofort & in Echtzeit", w4d: "Das Ergebnis ändert sich beim Tippen. Kein Berechnen-Button nötig.",
        w5t: "Flexible Rate", w5d: "Von 10 % bis 100 % schieben — passend zu deiner Vereinbarung.",
        w6t: "Kostenlos & privat", w6d: "Alle Berechnungen laufen in deinem Browser. Keine Daten werden gesendet oder gespeichert.",
        h0: "SO FUNKTIONIERT'S", ha: "Drei Schritte,", hb: "fertig.",
        h1t: "Abo-Details eingeben", h1d: "App-Name, Kaufpreis und gesamte Premium-Laufzeit — z. B. 30 Tage.",
        h2t: "Resttage hinzufügen", h2d: "Wie viele Tage bis zum Abo-Ende bleiben.",
        h3t: "Rate einstellen, Ergebnis sehen", h3d: "Erstattungsrate 10 %–100 % schieben, die Schätzung erscheint sofort.",
        fa: "Häufig gestellte", fb: "Fragen.",
        q1: "Ist Refundaja kostenlos?", a1: "Ja — 100 % für immer kostenlos. Kein Login, keine Werbung, keine Limits.",
        q2: "Wie funktioniert die Berechnung?", a2: "Kaufpreis geteilt durch Gesamtlaufzeit ergibt den Tageswert, dann multipliziert mit Resttagen und Rate.",
        q3: "Was ist die Erstattungsrate?", a3: "Der Prozentsatz des Restwerts, der erstattet wird — 0.70 heißt 70 %.",
        q4: "Werden meine Daten gespeichert?", a4: "Nein. Alles läuft in deinem Browser, nichts wird an Server gesendet.",
        q5: "Welche Apps werden unterstützt?", a5: "Alle Premium-Abos — Netflix, Spotify, YouTube Premium, Canva und mehr.",
        ft1: "Premium-App-Erstattungsrechner — sofort, kostenlos und genau.",
        ft2: "© 2026 Refundaja. Mit Sorgfalt gemacht.",
        ft3: "Refundaja ist ein unabhängiges Schätzwerkzeug und keinem Anbieter angehörig.",
    },
    nl: {
        n1: "Calculator", n2: "Hoe het werkt", n3: "FAQ", n4: "Bereken refund", n5: "Deel Refundaja",
        badge: "PREMIUM REFUND CALCULATOR",
        h1a: "Premium app-refund,", h1b: "tot de laatste", h1c1: "roepia", h1c2: "berekend.",
        sub: "Voer prijs, duur en resterende dagen in — Refundaja berekent je terugbetaling direct. Gratis, zonder login.",
        cta1: "Bereken je refund nu", cta2: "Bekijk hoe het werkt",
        c1: "100% gratis", c2: "Direct resultaat", c3: "Zonder login",
        ke: "CALCULATOR", kt1: "Hoeveel kun je", kt2: "terugkrijgen?",
        kd: "Alles wordt direct in je browser berekend — resultaat verandert terwijl je typt.",
        t1: "Refund berekenen", t2: "Resterende dagen",
        f1: "Naam van app", f1p: "Bijv.: Netflix, Spotify…", f2: "Aankoopprijs (Rp)",
        f2h: "Voer de basisprijs in zonder admin-kosten. Bijv.: Rp 30.260 betaald → Rp 30.000 invullen",
        f3: "Resterende actieve dagen", f4: "Totale premiumduur (dagen)", f5: "Refundpercentage",
        fH: "Prijs", fD: "Duur", fS: "Dagen over",
        r1: "Totale refund", r2: "vul het formulier in", r3: "Geschatte refund", r4: "Resterende duur",
        r5: "Waarde per dag", r6: "Servicekosten",
        r7: "Schatting — geen definitief bedrag van de aanbieder. Formule: (prijs ÷ duur) × dagen over × percentage.",
        s2: "Aankoopdatum", s3: "Abonnementsduur", s4p: "Bijv.: 45", s5: "Reset",
        s6: "Nog actief", s7: "Verlopen", s8: "dagen over", s9: "dagen voorbij", s10: "dagen totaal",
        s11: "Start", s12: "Einde", s13: "Opslaan in agenda", s14: "Opgeslagen",
        s16: "kies aangepaste duur & vul dagen in",
        w1: "WAAROM REFUNDAJA", w2a: "Klein, maar", w2b: "serieus.",
        w3t: "Open formule, geen giswerk",
        wfd: "Elke roepia is te traceren. Geen magische getallen — alleen simpele, transparante rekenkunde.",
        w4t: "Direct & realtime", w4d: "Resultaat verandert terwijl je typt. Geen berekenknop nodig.",
        w5t: "Flexibel percentage", w5d: "Schuif van 10% tot 100% — volgens jouw afspraak.",
        w6t: "Gratis & privé", w6d: "Alle berekeningen in je browser. Er wordt niets verstuurd of opgeslagen.",
        h0: "HOE HET WERKT", ha: "Drie stappen,", hb: "klaar.",
        h1t: "Vul abonnementsdetails in", h1d: "App-naam, aankoopprijs en totale premiumduur — bijv. 30 dagen.",
        h2t: "Voeg resterende dagen toe", h2d: "Hoeveel dagen tot je abonnement afloopt.",
        h3t: "Stel percentage in, zie resultaat", h3d: "Schuif het refundpercentage 10%–100% en je schatting verschijnt.",
        fa: "Veelgestelde", fb: "vragen.",
        q1: "Is Refundaja gratis?", a1: "Ja — 100% voor altijd gratis. Geen login, geen advertenties, geen limieten.",
        q2: "Hoe werkt de berekening?", a2: "Aankoopprijs gedeeld door totale duur geeft de dagwaarde, daarna vermenigvuldigd met dagen over en percentage.",
        q3: "Wat is het refundpercentage?", a3: "Het afgesproken percentage van de restwaarde — 0.70 betekent 70%.",
        q4: "Worden mijn gegevens opgeslagen?", a4: "Nee. Alles draait in je browser, niets wordt naar een server gestuurd.",
        q5: "Welke apps worden ondersteund?", a5: "Elk premium abonnement — Netflix, Spotify, YouTube Premium, Canva en meer.",
        ft1: "Premium app-refund calculator — direct, gratis en nauwkeurig.",
        ft2: "© 2026 Refundaja. Met zorg gemaakt.",
        ft3: "Refundaja is een onafhankelijk schattingstool en niet gelieerd aan enige aanbieder.",
    },
    it: {
        n1: "Calcolatrice", n2: "Come funziona", n3: "FAQ", n4: "Calcola rimborso", n5: "Condividi Refundaja",
        badge: "CALCOLATRICE RIMBORSO PREMIUM",
        h1a: "Rimborso app premium,", h1b: "fino all'ultima", h1c1: "rupia", h1c2: "calcolata.",
        sub: "Inserisci prezzo, durata e giorni rimanenti — Refundaja stima il tuo rimborso in un attimo. Gratis, senza login.",
        cta1: "Calcola il mio rimborso", cta2: "Vedi come funziona",
        c1: "100% gratis", c2: "Risultato immediato", c3: "Senza login",
        ke: "CALCOLATRICE", kt1: "Quanto puoi", kt2: "recuperare?",
        kd: "Tutto viene calcolato nel tuo browser — il risultato cambia mentre scrivi.",
        t1: "Calcola Rimborso", t2: "Giorni Rimanenti",
        f1: "Nome dell'app", f1p: "Es: Netflix, Spotify…", f2: "Prezzo di acquisto (Rp)",
        f2h: "Inserisci il prezzo base senza commissioni. Es: pagato Rp 30.260 → scrivi Rp 30.000",
        f3: "Giorni attivi rimanenti", f4: "Durata totale premium (giorni)", f5: "Tasso di rimborso",
        fH: "Prezzo", fD: "Durata", fS: "Giorni rimasti",
        r1: "Rimborso totale", r2: "compila il modulo per calcolare", r3: "Rimborso stimato", r4: "Durata rimanente",
        r5: "Valore al giorno", r6: "Commissione",
        r7: "Stima — non la cifra finale del fornitore. Formula: (prezzo ÷ durata) × giorni rimasti × tasso.",
        s2: "Data di acquisto", s3: "Durata abbonamento", s4p: "Es: 45", s5: "Reimposta",
        s6: "Ancora attivo", s7: "Scaduto", s8: "giorni rimasti", s9: "giorni trascorsi", s10: "giorni totali",
        s11: "Inizio", s12: "Fine", s13: "Salva in calendario", s14: "Salvato",
        s16: "scegli durata personalizzata e inserisci i giorni",
        w1: "PERCHÉ REFUNDAJA", w2a: "Piccola, ma", w2b: "seria.",
        w3t: "Formula aperta, niente congetture",
        wfd: "Ogni rupia è tracciabile. Nessun numero magico — solo aritmetica semplice e trasparente.",
        w4t: "Immediato e in tempo reale", w4d: "Il risultato cambia mentre scrivi. Nessun pulsante calcola.",
        w5t: "Tasso flessibile", w5d: "Scorri dal 10% al 100% — secondo il tuo accordo.",
        w6t: "Gratis e privato", w6d: "Tutto calcolato nel tuo browser. Nessun dato inviato o salvato.",
        h0: "COME FUNZIONA", ha: "Tre passaggi,", hb: "fatto.",
        h1t: "Inserisci i dettagli dell'abbonamento", h1d: "Nome app, prezzo di acquisto e durata totale — es. 30 giorni.",
        h2t: "Aggiungi i giorni rimanenti", h2d: "Quanti giorni mancano alla fine del tuo abbonamento.",
        h3t: "Imposta il tasso, vedi il risultato", h3d: "Scorri il tasso 10%–100%, la stima appare subito.",
        fa: "Domande", fb: "frequenti.",
        q1: "Refundaja è gratis?", a1: "Sì — 100% gratis per sempre. Nessun login, pubblicità o limite.",
        q2: "Come funziona il calcolo?", a2: "Il prezzo diviso per la durata totale dà il valore giornaliero, poi moltiplicato per giorni rimasti e tasso.",
        q3: "Cos'è il tasso di rimborso?", a3: "La percentuale del valore rimanente concordata per il rimborso — 0.70 cioè 70%.",
        q4: "I miei dati vengono salvati?", a4: "No. Tutto gira nel tuo browser, nulla viene inviato ai server.",
        q5: "Quali app sono supportate?", a5: "Tutti gli abbonamenti premium — Netflix, Spotify, YouTube Premium, Canva e altri.",
        ft1: "Calcolatrice rimborso app premium — immediata, gratuita e precisa.",
        ft2: "© 2026 Refundaja. Fatta con cura.",
        ft3: "Refundaja è uno strumento di stima indipendente, non affiliato ad alcun fornitore.",
    },
    sw: {
        n1: "Kikokotoo", n2: "Jinsi inavyofanya kazi", n3: "Maswali", n4: "Kokotoa Rejesha", n5: "Shiriki Refundaja",
        badge: "KIKOKOTOO CHA REJESHO LA PREMIUM",
        h1a: "Rejesho la app", h1b: "premium, haki", h1c1: "hadi rupia", h1c2: "ya mwisho.",
        sub: "Ingiza bei, muda, na siku zinazobaki — Refundaja hukokotoa marejesho yako papo hapo. Bure, bila kuingia.",
        cta1: "Kokotoa Rejesha Sasa", cta2: "Ona Jinsi Inavyofanya Kazi",
        c1: "Bure 100%", c2: "Matokeo papo hapo", c3: "Bila kuingia",
        ke: "KIKOKOTOO", kt1: "Unaweza kupata", kt2: "ngapi tena?",
        kd: "Yote hukokotwa kwenye kivinjari chako — matokeo hubadilika unapoandika.",
        t1: "Kokotoa Rejesha", t2: "Kokotoa Siku Zilizobaki",
        f1: "Jina la App", f1p: "Mf.: Netflix, Spotify…", f2: "Bei ya Ununuzi (Rp)",
        f2h: "Ingiza bei ya msingi bila ada. Mf.: ulipea Rp 30.260 → andika Rp 30.000",
        f3: "Siku Zinazofanya Kazi", f4: "Muda Wote wa Premium (Siku)", f5: "Kiwango cha Rejesha",
        fH: "Bei", fD: "Muda", fS: "Siku zilizobaki",
        r1: "Jumla ya Rejesha", r2: "jaza fomu kukokotoa", r3: "Rejesha la kukadiriwa", r4: "Muda Uliobaki",
        r5: "Thamani kwa siku", r6: "Ada ya Huduma",
        r7: "Makadirio — si takwimu ya mwisho ya mtoa huduma. Mfumo: (bei ÷ muda) × siku zilizobaki × kiwango.",
        s2: "Tarehe ya Ununuzi", s3: "Muda wa Usajili", s4p: "Mf.: 45", s5: "Weka upya",
        s6: "Bado hai", s7: "Imeisha muda", s8: "siku zilizobaki", s9: "siku zimepita", s10: "jumla ya siku",
        s11: "Anza", s12: "Maliza", s13: "Hifadhi kwenye Kalenda", s14: "Imehifadhiwa",
        s16: "chagua muda wa Custom & jaza siku",
        w1: "KWA NINI REFUNDAJA", w2a: "Ndogo, lakini", w2b: "makini.",
        w3t: "Mfumo wazi, bila kubahatisha",
        wfd: "Kila rupia inaweza kufuatiliwa. Hakuna namba za ajabu — hesabu rahisi na wazi tu.",
        w4t: "Papo hapo & wakati halisi", w4d: "Matokeo hubadilika unapoandika. Hakuna kitufe cha kokotoa.",
        w5t: "Kiwango chenye kubadilika", w5d: "Sogeza kutoka 10% hadi 100% — kulingana na makubaliano yako.",
        w6t: "Bure & ya faragha", w6d: "Hesabu zote hukua kwenye kivinjari chako. Hakuna data inayotumwa au kuhifadhiwa.",
        h0: "JINSI INAVYOFANYA KAZI", ha: "Hatua tatu,", hb: "imeisha.",
        h1t: "Jaza maelezo ya usajili", h1d: "Jina la app, bei ya ununuzi, na muda wote wa premium — mf. siku 30.",
        h2t: "Ingiza siku zilizobaki", h2d: "Siku ngapi zimebaki kabla usajili wako uishe.",
        h3t: "Weka kiwango, ona matokeo", h3d: "Sogeza kiwango cha rejesho 10%–100%, makadirio yatatoka papo hapo.",
        fa: "Maswali", fb: "yanayoulizwa.",
        q1: "Je, Refundaja ni bure?", a1: "Ndiyo — 100% bure milele. Hakuna kuingia, matangazo, au mipaka.",
        q2: "Hesabu inafanyaje?", a2: "Bei ya ununuzi hugawiwa na muda wote kupata thamani ya siku, kisha kuzidishwa na siku zilizobaki na kiwango.",
        q3: "Kiwango cha rejesho ni nini?", a3: "Asilimia ya thamani iliyobaki iliyokubaliwa kurudishwa — 0.70 inamaanisha 70%.",
        q4: "Je, data yangu huhifadhiwa?", a4: "Hapana. Kila kitu hukua kwenye kivinjari chako, hakuna kinachotumwa seva.",
        q5: "Programu gani zinaunganishwa?", a5: "Usajili wowote wa premium — Netflix, Spotify, YouTube Premium, Canva, na zaidi.",
        ft1: "Kikokotoo cha rejesho la app za premium — papo hapo, bure, na sahihi.",
        ft2: "© 2026 Refundaja. Imetengenezwa kwa makini.",
        ft3: "Refundaja ni zana ya makadirio huru na haihusiani na mtoa huduma yeyote.",
    },
};

